import {c as chainsData,a as cookieKeys,b as configRef,p as prematchCoreAbi,O as ODDS_DECIMALS,d as prematchComboCoreAbi,l as liveHostAddress,m as minLiveBetAmount,e as localStorageKeys,f as liveSupportedChains,g as getApiUrl,h as environments,i as liveCoreAbi,D as DEFAULT_DEADLINE,j as deBridgeUrl,k as deBridgeTxUrl}from'./config.js';import {jsx,jsxs}from'react/jsx-runtime';import {createContext,useContext,useState,useRef,useMemo,useCallback,useEffect}from'react';import {useAccount,useConfig,useWatchContractEvent,useBalance,usePublicClient,useWalletClient,useReadContract,useWriteContract,useWaitForTransactionReceipt,useSendTransaction}from'wagmi';import {HttpLink,ApolloClient,InMemoryCache,gql,useQuery}from'@apollo/client';import {decodeEventLog,parseUnits,formatUnits,encodeAbiParameters,parseAbiParameters,erc20Abi,maxUint256,zeroAddress,encodeFunctionData}from'viem';import {readContracts,readContract,getTransactionReceipt}from'@wagmi/core';import {getMarketName,getSelectionName,dictionaries,getMarketKey,getMarketDescription}from'@azuro-org/dictionaries';import {useQuery as useQuery$1}from'@tanstack/react-query';import'viem/chains';var SportHub;
(function (SportHub) {
    SportHub["Sports"] = "sports";
    SportHub["Esports"] = "esports";
})(SportHub || (SportHub = {}));const ChainContext = createContext(null);
const useChain = () => {
    return useContext(ChainContext);
};
const ChainProvider = (props) => {
    const { children, initialChainId } = props;
    const [appChainId, setAppChainId] = useState(initialChainId);
    const { chain: walletChain } = useAccount();
    const walletChainId = walletChain?.id || null;
    const isRightNetwork = walletChainId === appChainId;
    const { chain, contracts, betToken, graphql, socket, api, environment } = chainsData[appChainId];
    const handleChangeChain = (chainId) => {
        document.cookie = `${cookieKeys.appChainId}=${chainId};path=/;`;
        setAppChainId(chainId);
    };
    const context = {
        appChain: chain,
        walletChain,
        contracts,
        betToken,
        graphql,
        socket,
        api,
        environment,
        isRightNetwork,
        setAppChainId: handleChangeChain,
    };
    return (jsx(ChainContext.Provider, { value: context, children: children }));
};const getPrematchLink = (chainId) => {
    return new HttpLink({
        uri: ({ operationName }) => `${chainsData[chainId].graphql.prematch}?op=${operationName}`,
    });
};
const getLiveLink = (chainId) => {
    return new HttpLink({
        uri: ({ operationName }) => `${chainsData[chainId].graphql.live}?op=${operationName}`,
    });
};
const getPrematchApolloClient = (chainId) => {
    const link = getPrematchLink(chainId);
    return new ApolloClient({
        link,
        ssrMode: typeof window === 'undefined',
        cache: new InMemoryCache(),
        connectToDevTools: true,
        assumeImmutableResults: true,
    });
};
const getLiveApolloClient = (chainId) => {
    const link = getLiveLink(chainId);
    return new ApolloClient({
        link,
        ssrMode: typeof window === 'undefined',
        cache: new InMemoryCache(),
        connectToDevTools: true,
        assumeImmutableResults: true,
    });
};
const apolloClients = {
    prematchClient: null,
    liveClient: null,
};
const getApolloClients = (chainId) => {
    if (typeof window === 'undefined') {
        return {
            prematchClient: getPrematchApolloClient(chainId),
            liveClient: getLiveApolloClient(chainId),
        };
    }
    if (!apolloClients.prematchClient) {
        apolloClients.prematchClient = getPrematchApolloClient(chainId);
        apolloClients.liveClient = getLiveApolloClient(chainId);
    }
    return apolloClients;
};
const Context = createContext(null);
const useApolloClients = () => {
    return useContext(Context);
};
const ApolloProvider = (props) => {
    const { children } = props;
    const { appChain } = useChain();
    const prevAppChainIdRef = useRef(appChain.id);
    const apolloClientsRef = useRef(getApolloClients(appChain.id));
    // set new link before render for send requests with new one
    useMemo(() => {
        if (appChain.id !== prevAppChainIdRef.current) {
            const { prematchClient, liveClient } = apolloClientsRef.current;
            const prematchLink = getPrematchLink(appChain.id);
            prematchClient.setLink(prematchLink);
            prematchClient.resetStore();
            if (chainsData[prevAppChainIdRef.current].graphql.live !== chainsData[appChain.id].graphql.live) {
                const liveLink = getLiveLink(appChain.id);
                liveClient.setLink(liveLink);
                liveClient.resetStore();
            }
            prevAppChainIdRef.current = appChain.id;
        }
    }, [appChain.id]);
    return (jsx(Context.Provider, { value: apolloClientsRef.current, children: children }));
};let ref = {
    lastUpdateTime: undefined,
};
const getGameStartsAtValue = () => {
    let startsAt;
    const dateNow = Math.floor(Date.now() / 1000);
    // if first render or current time is greater the previous saved more than cache time
    if (!ref.lastUpdateTime
        || dateNow - ref.lastUpdateTime > configRef.gamesCacheTime) {
        startsAt = dateNow;
        ref.lastUpdateTime = dateNow;
    }
    else {
        startsAt = ref.lastUpdateTime;
    }
    return startsAt;
};const getEventArgsFromTxReceipt = ({ receipt, eventName, abi, params }) => {
    const { logs } = receipt;
    let result;
    for (let index = 0; index < logs.length; index++) {
        try {
            const log = logs[index];
            result = decodeEventLog({
                abi,
                topics: log.topics,
                eventName,
                data: log.data,
            });
            if (result.eventName.toLowerCase() !== eventName.toLowerCase()) {
                result = undefined;
                continue;
            }
            if (params && result?.args) {
                const isMatchByParams = Object.keys(params).every(paramKey => {
                    return result.args[paramKey] === params[paramKey];
                });
                if (!isMatchByParams) {
                    result = undefined;
                }
            }
            if (result) {
                break;
            }
        }
        catch { }
    }
    if (result?.args) {
        return result?.args;
    }
};const formatToFixed = (value, digitsCount) => {
    value = String(value);
    if (!/\./.test(value)) {
        return +value;
    }
    const [int, digits] = value.split('.');
    return +`${int}.${digits.substr(0, digitsCount)}`;
};function debounce(func, wait, immediate) {
    let timeout;
    return function (...args) {
        const context = this;
        const later = function () {
            timeout = undefined;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && timeout === undefined;
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}const createBatch = (fn, isSet = true) => {
    let idsWaitList = isSet ? new Set() : [];
    let resolversWaitList = [];
    const request = debounce(async (fn, ...rest) => {
        const ids = [...idsWaitList];
        const resolvers = resolversWaitList;
        if (idsWaitList instanceof Set) {
            idsWaitList.clear();
        }
        else {
            idsWaitList = [];
        }
        resolversWaitList = [];
        try {
            const data = await fn(ids, ...rest);
            resolvers.forEach((resolve) => {
                resolve(data);
            });
        }
        catch (err) {
            resolvers.forEach((resolve) => {
                resolve(undefined);
            });
        }
    }, 50);
    const batch = (ids, ...rest) => {
        request(fn, ...rest);
        ids.forEach(id => {
            if (idsWaitList instanceof Set) {
                idsWaitList.add(id);
            }
            else {
                idsWaitList.push(id);
            }
        });
        return new Promise((resolve) => {
            resolversWaitList.push(resolve);
        });
    };
    return batch;
};const timers$1 = new Map();
const subscribers$1 = new Map();
const subscribe$1 = (conditionId, cb) => {
    const key = conditionId;
    const handlers = subscribers$1.get(key) || [];
    handlers.push({ cb });
    subscribers$1.set(key, handlers);
    return function unsubscribe() {
        const handlers = subscribers$1.get(key) || [];
        const newHandlers = handlers.filter((handler) => handler.cb !== cb);
        if (newHandlers.length) {
            subscribers$1.set(key, newHandlers);
        }
        else {
            subscribers$1.delete(key);
        }
    };
};
const trigger$1 = (conditionId, status) => {
    const handlers = subscribers$1.get(conditionId) || [];
    handlers.forEach(({ cb }) => {
        cb(status);
    });
};
const dispatch$1 = (conditionId, status) => {
    let timer = timers$1.get(conditionId);
    if (timer !== undefined) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        timers$1.delete(conditionId);
        trigger$1(conditionId, status);
    }, 200);
    timers$1.set(conditionId, timer);
};
const conditionStatusWatcher = {
    subscribe: subscribe$1,
    dispatch: dispatch$1,
};const timers = new Map();
const subscribers = new Map();
const subscribe = (conditionId, outcomeId, cb) => {
    const key = conditionId;
    const handlers = subscribers.get(key) || [];
    handlers.push({ outcomeId, cb });
    subscribers.set(key, handlers);
    return function unsubscribe() {
        const handlers = subscribers.get(key) || [];
        const newHandlers = handlers.filter((handler) => handler.cb !== cb);
        if (newHandlers.length) {
            subscribers.set(key, newHandlers);
        }
        else {
            subscribers.delete(key);
        }
    };
};
const trigger = async (conditionId, oddsData) => {
    const handlers = subscribers.get(conditionId) || [];
    handlers.forEach(({ cb }) => {
        cb(oddsData);
    });
};
const dispatch = (conditionId, oddsData) => {
    let timer = timers.get(conditionId);
    if (timer !== undefined) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        timers.delete(conditionId);
        trigger(conditionId, oddsData);
    }, 200);
    timers.set(conditionId, timer);
};
const oddsWatcher = {
    subscribe,
    dispatch,
};const SocketContext = createContext(null);
const useSocket = () => {
    return useContext(SocketContext);
};
const SocketProvider = ({ children }) => {
    const { appChain } = useChain();
    const [isSocketReady, setSocketReady] = useState(false);
    const prevChainId = useRef(appChain.id);
    const socket = useRef();
    const subscribers = useRef({});
    const subscribe = useCallback((conditionIds) => {
        if (!isSocketReady) {
            throw Error('socket isn\'t ready');
        }
        conditionIds.forEach((conditionId) => {
            if (typeof subscribers.current[conditionId] === 'undefined') {
                subscribers.current[conditionId] = 0;
            }
            subscribers.current[conditionId] += 1;
        });
        socket.current.send(JSON.stringify({
            action: 'subscribe',
            conditionIds,
        }));
    }, [isSocketReady]);
    const unsubscribe = useCallback((conditionIds) => {
        if (!isSocketReady) {
            throw Error('socket isn\'t ready');
        }
        // we mustn't unsubscribe for condition if it has more that 1 subscriber
        const newUnsubscribers = [];
        conditionIds.forEach((conditionId) => {
            if (subscribers.current[conditionId]) {
                if (subscribers.current[conditionId] > 1) {
                    subscribers.current[conditionId] -= 1;
                }
                else {
                    subscribers.current[conditionId] = 0;
                    newUnsubscribers.push(conditionId);
                }
            }
        });
        if (!newUnsubscribers.length) {
            return;
        }
        socket.current.send(JSON.stringify({
            action: 'unsubscribe',
            conditionIds: newUnsubscribers,
        }));
    }, [isSocketReady]);
    const subscribeToUpdates = useCallback(createBatch(subscribe), [subscribe]);
    const unsubscribeToUpdates = useCallback(createBatch(unsubscribe), [unsubscribe]);
    const connect = () => {
        socket.current = new WebSocket(chainsData[appChain.id].socket);
        socket.current.onopen = () => {
            setSocketReady(true);
        };
        socket.current.onmessage = (message) => {
            JSON.parse(message.data.toString()).forEach((data) => {
                const { id: conditionId, reinforcement, margin, winningOutcomesCount } = data;
                if (data.outcomes) {
                    const eventData = {
                        conditionId: conditionId,
                        reinforcement: +reinforcement,
                        margin: +margin,
                        winningOutcomesCount: +winningOutcomesCount,
                        outcomes: {},
                    };
                    eventData.outcomes = data.outcomes.reduce((acc, { id, odds, clearOdds, maxStake }) => {
                        acc[id] = {
                            odds,
                            clearOdds,
                            maxBet: maxStake,
                        };
                        return acc;
                    }, {});
                    oddsWatcher.dispatch(conditionId, eventData);
                }
                if (data.state) {
                    conditionStatusWatcher.dispatch(conditionId, data.state);
                }
            });
        };
        socket.current.onerror = () => {
            socket.current = undefined;
            setSocketReady(false);
            setTimeout(connect, 1000);
        };
    };
    useEffect(() => {
        if (isSocketReady
            && socket.current
            && prevChainId.current !== appChain.id
            && chainsData[prevChainId.current].socket !== chainsData[appChain.id].socket) {
            unsubscribe(Object.keys(subscribers.current));
            socket.current.close();
            socket.current = undefined;
            setSocketReady(false);
        }
        prevChainId.current = appChain.id;
    }, [appChain, isSocketReady]);
    useEffect(() => {
        if (typeof socket.current !== 'undefined') {
            return;
        }
        connect();
    }, [appChain]);
    const value = {
        isSocketReady,
        subscribeToUpdates,
        unsubscribeToUpdates,
    };
    return (jsx(SocketContext.Provider, { value: value, children: children }));
};const MainGameInfoFragmentDoc = gql `
    fragment MainGameInfo on Game {
  id
  gameId
  title
  startsAt
  status
  sport {
    sportId
    slug
    name
  }
  league {
    slug
    name
    country {
      slug
      name
    }
  }
  participants {
    image
    name
  }
}
    `;const ratio = (self, other) => (self > other ? self / other : other / self);
const sigmoid = (value) => value / (value + 1);
const getOddsFromProbabilities = (probabilities, margin, winningOutcomesCount = 1) => {
    const precision = 0.0001;
    const maxIterations = 10;
    const odds = {};
    const spreads = Object.keys(probabilities).reduce((acc, outcomeId) => {
        acc[+outcomeId] = (1 - probabilities[+outcomeId]) * margin;
        return acc;
    }, {});
    let error = margin;
    for (let iteration = 0; iteration < maxIterations; iteration++) {
        let oddsSpread;
        {
            let spread = 0;
            Object.keys(probabilities).forEach(outcomeId => {
                const price = (1 - spreads[+outcomeId]) / probabilities[+outcomeId];
                odds[+outcomeId] = price;
                spread += 1 / price;
            });
            oddsSpread = 1 - winningOutcomesCount / spread;
        }
        if (ratio(margin, oddsSpread) - 1 < precision) {
            return odds;
        }
        if (margin <= oddsSpread) {
            throw new Error('margin <= oddsSpread');
        }
        const newError = margin - oddsSpread;
        if (newError === error) {
            if (margin / oddsSpread - 1 >= precision) {
                throw new Error('margin / oddsSpread - 1 >= precision');
            }
            return odds;
        }
        error = newError;
        Object.keys(spreads).forEach(outcomeId => {
            spreads[+outcomeId] +=
                (1 - spreads[+outcomeId] - probabilities[+outcomeId]) *
                    sigmoid((error * spreads[+outcomeId]) / (1 - 1 / odds[+outcomeId]) / (1 - margin) / oddsSpread);
        });
    }
    throw new Error(`Can't calculate odds from given params: ${JSON.stringify(probabilities)} / ${margin} / ${winningOutcomesCount}`);
};
const calcLiveOdds = ({ selection, betAmount, oddsData }) => {
    const { outcomeId: _outcomeId } = selection;
    const { margin, reinforcement, winningOutcomesCount, outcomes } = oddsData;
    const outcomeId = Number(_outcomeId);
    let allFunds = 0;
    const funds = Object.keys(outcomes).reduce((acc, outcomeKey) => {
        const { clearOdds } = outcomes[+outcomeKey];
        const probability = 1 / clearOdds;
        let fund = reinforcement * probability;
        if (outcomeId === +outcomeKey) {
            fund += Number(betAmount || '');
        }
        allFunds += fund;
        acc[+outcomeKey] = fund;
        return acc;
    }, {});
    const probabilities = Object.keys(funds).reduce((acc, outcomeKey) => {
        const fund = funds[+outcomeKey];
        acc[+outcomeKey] = fund / allFunds;
        return acc;
    }, {});
    const odds = getOddsFromProbabilities(probabilities, margin, winningOutcomesCount);
    if (odds[outcomeId] > outcomes[outcomeId].odds) {
        return outcomes[outcomeId].odds;
    }
    return formatToFixed(odds[outcomeId], 2);
};
const calcPrematchOdds = async (props) => {
    const { config, selections, betAmount, chainId, batchBetAmounts } = props;
    const { betToken, contracts } = chainsData[chainId];
    const isBatch = Boolean(Object.keys(batchBetAmounts || {}).length);
    if (selections.length === 1 || isBatch) {
        let odds = {};
        const contracts = selections.map(({ conditionId, outcomeId, coreAddress }) => {
            const _betAmount = isBatch ? batchBetAmounts?.[`${conditionId}-${outcomeId}`] : betAmount;
            const rawAmount = parseUnits(_betAmount || '', betToken.decimals);
            return {
                abi: prematchCoreAbi,
                address: coreAddress,
                chainId,
                functionName: 'calcOdds',
                args: [BigInt(conditionId), rawAmount, BigInt(outcomeId)],
            };
        });
        try {
            const response = await readContracts(config, {
                contracts,
            });
            odds = selections.reduce((acc, { conditionId, outcomeId }, index) => {
                const result = response[index]?.result;
                acc[`${conditionId}-${outcomeId}`] = formatToFixed(formatUnits(typeof result === 'bigint' ? result : 0n, ODDS_DECIMALS), 3);
                return acc;
            }, {});
        }
        catch { }
        return odds;
    }
    if (selections.length > 1) {
        const rawAmount = parseUnits(betAmount || '', betToken.decimals);
        const expressAddress = contracts.prematchComboCore.address;
        const subBets = selections.map(({ conditionId, outcomeId }) => ({
            conditionId: BigInt(conditionId),
            outcomeId: BigInt(outcomeId),
        }));
        try {
            const [conditionOdds] = await readContract(config, {
                abi: prematchComboCoreAbi,
                address: expressAddress,
                chainId,
                functionName: 'calcOdds',
                args: [subBets, rawAmount],
            });
            return selections.reduce((acc, { conditionId, outcomeId }, index) => {
                const key = `${conditionId}-${outcomeId}`;
                acc[key] = formatToFixed(formatUnits(conditionOdds[index], ODDS_DECIMALS), 3);
                return acc;
            }, {});
        }
        catch { }
    }
    return {};
};const useIsMounted = () => {
    const isMountedRef = useRef(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    return () => isMountedRef.current;
};const useOdds = ({ selections, betAmount, batchBetAmounts }) => {
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const { appChain } = useChain();
    const config = useConfig();
    const isMounted = useIsMounted();
    const { liveItems, prematchItems } = useMemo(() => {
        return selections.reduce((acc, item) => {
            if (item.coreAddress.toLocaleLowerCase() === liveHostAddress.toLocaleLowerCase()) {
                acc.liveItems.push(item);
            }
            else {
                acc.prematchItems.push(item);
            }
            return acc;
        }, {
            liveItems: [],
            prematchItems: [],
        });
    }, [selections]);
    const [odds, setOdds] = useState({});
    const [totalOdds, setTotalOdds] = useState(1);
    const [isPrematchOddsFetching, setPrematchOddsFetching] = useState(Boolean(prematchItems.length));
    const oddsDataRef = useRef({});
    const betAmountRef = useRef(betAmount);
    const batchBetAmountsRef = useRef(batchBetAmounts);
    betAmountRef.current = betAmount;
    batchBetAmountsRef.current = batchBetAmounts;
    const liveKey = liveItems.map(({ conditionId }) => conditionId).join('-');
    const isLiveOddsFetching = useMemo(() => {
        return !liveItems.every(({ conditionId, outcomeId }) => Boolean(odds[`${conditionId}-${outcomeId}`]));
    }, [liveKey, odds]);
    const maxBet = useMemo(() => {
        if (!liveItems.length || liveItems.length > 1) {
            return undefined;
        }
        const { conditionId, outcomeId } = liveItems[0];
        return oddsDataRef.current?.[conditionId]?.outcomes?.[outcomeId]?.maxBet;
    }, [liveKey, odds]); // we need odds in deps because we update oddsDataRef with odds
    const fetchPrematchOdds = async () => {
        if (!prematchItems.length) {
            return;
        }
        try {
            const prematchOdds = await calcPrematchOdds({
                config,
                betAmount: betAmountRef.current,
                batchBetAmounts: batchBetAmountsRef.current,
                selections: prematchItems,
                chainId: appChain.id,
            });
            if (isMounted()) {
                setOdds(odds => {
                    const newOdds = { ...odds, ...prematchOdds };
                    const newTotalOdds = formatToFixed(Object.keys(newOdds).reduce((acc, key) => acc * +newOdds[key], 1), 3);
                    setTotalOdds(newTotalOdds);
                    return newOdds;
                });
                setPrematchOddsFetching(false);
            }
        }
        catch (err) {
            if (isMounted()) {
                setPrematchOddsFetching(false);
            }
        }
    };
    const fetchLiveOdds = (items, newOddsData) => {
        if (!items.length) {
            return;
        }
        if (newOddsData) {
            oddsDataRef.current[newOddsData.conditionId] = newOddsData;
        }
        const liveOdds = items.reduce((acc, item) => {
            const { conditionId, outcomeId } = item;
            const oddsData = oddsDataRef.current[conditionId];
            if (!oddsData) {
                return acc;
            }
            acc[`${conditionId}-${outcomeId}`] = calcLiveOdds({ selection: item, betAmount: betAmountRef.current, oddsData });
            return acc;
        }, {});
        setOdds(odds => {
            const newOdds = { ...odds, ...liveOdds };
            const newTotalOdds = formatToFixed(Object.keys(newOdds).reduce((acc, key) => acc * +newOdds[key], 1), 3);
            setTotalOdds(newTotalOdds);
            return newOdds;
        });
    };
    const fetchOdds = useCallback(debounce(() => {
        setOdds({});
        setTotalOdds(1);
        setPrematchOddsFetching(Boolean(prematchItems.length));
        fetchPrematchOdds();
        fetchLiveOdds(liveItems);
    }, 100), [selections]);
    useEffect(() => {
        if (!isSocketReady || !liveItems.length) {
            return;
        }
        const ids = liveKey.split('-');
        subscribeToUpdates(ids);
        return () => {
            unsubscribeToUpdates(ids);
        };
    }, [liveKey, isSocketReady]);
    useEffect(() => {
        fetchOdds();
    }, [fetchOdds, betAmount, batchBetAmounts]);
    useEffect(() => {
        if (!selections?.length) {
            return;
        }
        const unsubscribeList = selections.map(({ conditionId, outcomeId }) => {
            return oddsWatcher.subscribe(`${conditionId}`, `${outcomeId}`, (oddsData) => {
                if (oddsData) {
                    const item = liveItems.find(item => item.conditionId === oddsData.conditionId);
                    fetchLiveOdds([item], oddsData);
                }
                else {
                    setPrematchOddsFetching(true);
                    fetchPrematchOdds();
                }
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selections]);
    return {
        odds,
        totalOdds,
        maxBet,
        loading: isPrematchOddsFetching || isLiveOddsFetching,
    };
};const ConditionsBatchDocument = gql `
    query conditionsBatch($conditionFilter: Condition_filter) {
  conditions(where: $conditionFilter, first: 1000, subgraphError: allow) {
    id
    status
    conditionId
    outcomes {
      id
      outcomeId
      odds: currentOdds
    }
  }
}
    `;const getConditions = (conditionIds, client) => {
    return client.query({
        query: ConditionsBatchDocument,
        variables: {
            conditionFilter: {
                conditionId_in: conditionIds,
            },
        },
        fetchPolicy: 'network-only',
    });
};
const batchFetchConditions = createBatch(getConditions);const useStatuses = ({ selections }) => {
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const { prematchClient } = useApolloClients();
    const [statuses, setStatuses] = useState({});
    const { liveItems, prematchItems } = useMemo(() => {
        return selections.reduce((acc, item) => {
            if (item.coreAddress.toLocaleLowerCase() === liveHostAddress.toLocaleLowerCase()) {
                acc.liveItems.push(item);
            }
            else {
                acc.prematchItems.push(item);
            }
            return acc;
        }, {
            liveItems: [],
            prematchItems: [],
        });
    }, [selections]);
    const [isPrematchStatusesFetching, setPrematchStatusesFetching] = useState(Boolean(prematchItems.length));
    const liveKey = liveItems.map(({ conditionId }) => conditionId).join('-');
    const selectionsKey = selections.map(({ conditionId }) => conditionId).join('-');
    const isLiveStatusesFetching = useMemo(() => {
        return !liveItems.every(({ conditionId }) => Boolean(statuses[conditionId]));
    }, [liveKey, statuses]);
    useEffect(() => {
        if (!isSocketReady || !liveItems.length) {
            return;
        }
        const ids = liveKey.split('-');
        subscribeToUpdates(ids);
        return () => {
            unsubscribeToUpdates(ids);
        };
    }, [liveKey, isSocketReady]);
    useEffect(() => {
        if (!selections.length) {
            return;
        }
        setStatuses({});
        const unsubscribeList = selections.map(({ conditionId }) => {
            return conditionStatusWatcher.subscribe(conditionId, (newStatus) => {
                setStatuses(statuses => ({
                    ...statuses,
                    [conditionId]: newStatus,
                }));
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selectionsKey]);
    useEffect(() => {
        if (!prematchItems.length) {
            return;
        }
        setPrematchStatusesFetching(true);
        (async () => {
            const { data: { conditions } } = await batchFetchConditions(prematchItems.map(({ conditionId }) => conditionId), prematchClient);
            const prematchStatuses = conditions.reduce((acc, { conditionId, status }) => {
                acc[conditionId] = status;
                return acc;
            }, {});
            setPrematchStatusesFetching(false);
            setStatuses(statuses => ({
                ...statuses,
                ...prematchStatuses,
            }));
        })();
    }, [prematchItems]);
    return {
        statuses,
        loading: isPrematchStatusesFetching || isLiveStatusesFetching,
    };
};var ConditionStatus$1;
(function (ConditionStatus) {
    ConditionStatus["Canceled"] = "Canceled";
    ConditionStatus["Created"] = "Created";
    ConditionStatus["Paused"] = "Paused";
    ConditionStatus["Resolved"] = "Resolved";
})(ConditionStatus$1 || (ConditionStatus$1 = {}));
var Condition_OrderBy$1;
(function (Condition_OrderBy) {
    Condition_OrderBy["UpdatedAt"] = "_updatedAt";
    Condition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    Condition_OrderBy["ConditionId"] = "conditionId";
    Condition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Condition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Condition_OrderBy["CreatedTxHash"] = "createdTxHash";
    Condition_OrderBy["Game"] = "game";
    Condition_OrderBy["Id"] = "id";
    Condition_OrderBy["InternalStartsAt"] = "internalStartsAt";
    Condition_OrderBy["Outcomes"] = "outcomes";
    Condition_OrderBy["OutcomesIds"] = "outcomesIds";
    Condition_OrderBy["Provider"] = "provider";
    Condition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Condition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Condition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Condition_OrderBy["Status"] = "status";
    Condition_OrderBy["Turnover"] = "turnover";
    Condition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    Condition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(Condition_OrderBy$1 || (Condition_OrderBy$1 = {}));
var Country_OrderBy$1;
(function (Country_OrderBy) {
    Country_OrderBy["ActiveLeaguesEntityIds"] = "activeLeaguesEntityIds";
    Country_OrderBy["HasActiveLeagues"] = "hasActiveLeagues";
    Country_OrderBy["Id"] = "id";
    Country_OrderBy["Leagues"] = "leagues";
    Country_OrderBy["Name"] = "name";
    Country_OrderBy["Slug"] = "slug";
    Country_OrderBy["Sport"] = "sport";
    Country_OrderBy["Turnover"] = "turnover";
})(Country_OrderBy$1 || (Country_OrderBy$1 = {}));
var EventName$1;
(function (EventName) {
    EventName["ConditionCreated"] = "ConditionCreated";
    EventName["ConditionResolved"] = "ConditionResolved";
    EventName["ConditionStopped"] = "ConditionStopped";
    EventName["GameCanceled"] = "GameCanceled";
    EventName["GameUpdated"] = "GameUpdated";
    EventName["NewGame"] = "NewGame";
})(EventName$1 || (EventName$1 = {}));
var Event_OrderBy$1;
(function (Event_OrderBy) {
    Event_OrderBy["BlockNumber"] = "blockNumber";
    Event_OrderBy["BlockTimestamp"] = "blockTimestamp";
    Event_OrderBy["ConditionId"] = "conditionId";
    Event_OrderBy["ContractAddress"] = "contractAddress";
    Event_OrderBy["GameId"] = "gameId";
    Event_OrderBy["GasPrice"] = "gasPrice";
    Event_OrderBy["GasUsed"] = "gasUsed";
    Event_OrderBy["Id"] = "id";
    Event_OrderBy["LogIndex"] = "logIndex";
    Event_OrderBy["Name"] = "name";
    Event_OrderBy["SortOrder"] = "sortOrder";
    Event_OrderBy["TransactionIndex"] = "transactionIndex";
    Event_OrderBy["TxHash"] = "txHash";
})(Event_OrderBy$1 || (Event_OrderBy$1 = {}));
var GameStatus$2;
(function (GameStatus) {
    GameStatus["Canceled"] = "Canceled";
    GameStatus["Created"] = "Created";
    GameStatus["Finished"] = "Finished";
    GameStatus["Paused"] = "Paused";
    GameStatus["Resolved"] = "Resolved";
})(GameStatus$2 || (GameStatus$2 = {}));
var Game_OrderBy$1;
(function (Game_OrderBy) {
    Game_OrderBy["ActiveConditionsEntityIds"] = "_activeConditionsEntityIds";
    Game_OrderBy["CanceledConditionsEntityIds"] = "_canceledConditionsEntityIds";
    Game_OrderBy["ResolvedConditionsEntityIds"] = "_resolvedConditionsEntityIds";
    Game_OrderBy["UpdatedAt"] = "_updatedAt";
    Game_OrderBy["Conditions"] = "conditions";
    Game_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Game_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Game_OrderBy["CreatedTxHash"] = "createdTxHash";
    Game_OrderBy["FinishedBlockNumber"] = "finishedBlockNumber";
    Game_OrderBy["FinishedBlockTimestamp"] = "finishedBlockTimestamp";
    Game_OrderBy["FinishedTxHash"] = "finishedTxHash";
    Game_OrderBy["GameId"] = "gameId";
    Game_OrderBy["HasActiveConditions"] = "hasActiveConditions";
    Game_OrderBy["Id"] = "id";
    Game_OrderBy["League"] = "league";
    Game_OrderBy["Participants"] = "participants";
    Game_OrderBy["Provider"] = "provider";
    Game_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Game_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Game_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Game_OrderBy["ShiftedBlockNumber"] = "shiftedBlockNumber";
    Game_OrderBy["ShiftedBlockTimestamp"] = "shiftedBlockTimestamp";
    Game_OrderBy["ShiftedTxHash"] = "shiftedTxHash";
    Game_OrderBy["Slug"] = "slug";
    Game_OrderBy["Sport"] = "sport";
    Game_OrderBy["StartsAt"] = "startsAt";
    Game_OrderBy["Status"] = "status";
    Game_OrderBy["Title"] = "title";
    Game_OrderBy["Turnover"] = "turnover";
})(Game_OrderBy$1 || (Game_OrderBy$1 = {}));
var League_OrderBy$1;
(function (League_OrderBy) {
    League_OrderBy["ActiveGamesEntityIds"] = "activeGamesEntityIds";
    League_OrderBy["Country"] = "country";
    League_OrderBy["Games"] = "games";
    League_OrderBy["HasActiveGames"] = "hasActiveGames";
    League_OrderBy["Id"] = "id";
    League_OrderBy["Name"] = "name";
    League_OrderBy["Slug"] = "slug";
    League_OrderBy["Turnover"] = "turnover";
})(League_OrderBy$1 || (League_OrderBy$1 = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection$1;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection$1 || (OrderDirection$1 = {}));
var Outcome_OrderBy$1;
(function (Outcome_OrderBy) {
    Outcome_OrderBy["UpdatedAt"] = "_updatedAt";
    Outcome_OrderBy["Condition"] = "condition";
    Outcome_OrderBy["Id"] = "id";
    Outcome_OrderBy["OutcomeId"] = "outcomeId";
    Outcome_OrderBy["Result"] = "result";
    Outcome_OrderBy["SortOrder"] = "sortOrder";
})(Outcome_OrderBy$1 || (Outcome_OrderBy$1 = {}));
var Participant_OrderBy$1;
(function (Participant_OrderBy) {
    Participant_OrderBy["Game"] = "game";
    Participant_OrderBy["Id"] = "id";
    Participant_OrderBy["Image"] = "image";
    Participant_OrderBy["Name"] = "name";
    Participant_OrderBy["SortOrder"] = "sortOrder";
})(Participant_OrderBy$1 || (Participant_OrderBy$1 = {}));
var SelectionResult$1;
(function (SelectionResult) {
    SelectionResult["Lost"] = "Lost";
    SelectionResult["Won"] = "Won";
})(SelectionResult$1 || (SelectionResult$1 = {}));
var SportHub_OrderBy$1;
(function (SportHub_OrderBy) {
    SportHub_OrderBy["Id"] = "id";
    SportHub_OrderBy["Name"] = "name";
    SportHub_OrderBy["Slug"] = "slug";
    SportHub_OrderBy["Sports"] = "sports";
})(SportHub_OrderBy$1 || (SportHub_OrderBy$1 = {}));
var Sport_OrderBy$1;
(function (Sport_OrderBy) {
    Sport_OrderBy["Countries"] = "countries";
    Sport_OrderBy["Games"] = "games";
    Sport_OrderBy["Id"] = "id";
    Sport_OrderBy["Name"] = "name";
    Sport_OrderBy["Slug"] = "slug";
    Sport_OrderBy["SportId"] = "sportId";
    Sport_OrderBy["Sporthub"] = "sporthub";
})(Sport_OrderBy$1 || (Sport_OrderBy$1 = {}));
var _SubgraphErrorPolicy_$1;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_$1 || (_SubgraphErrorPolicy_$1 = {}));const formatBetValue = (value) => {
    let newValue = value;
    const [int, digits] = newValue.split('.');
    if (digits) {
        newValue = `${int}.${digits.substring(0, 2)}`;
    }
    return newValue;
};var BetslipDisableReason;
(function (BetslipDisableReason) {
    BetslipDisableReason["ConditionStatus"] = "ConditionStatus";
    BetslipDisableReason["BetAmountGreaterThanMaxBet"] = "BetAmountGreaterThanMaxBet";
    BetslipDisableReason["BetAmountLowerThanMinBet"] = "BetAmountLowerThanMinBet";
    BetslipDisableReason["BatchWithLive"] = "BatchWithLive";
    BetslipDisableReason["ComboWithLive"] = "ComboWithLive";
    BetslipDisableReason["ComboWithForbiddenItem"] = "ComboWithForbiddenItem";
    BetslipDisableReason["ComboWithSameGame"] = "ComboWithSameGame";
    BetslipDisableReason["PrematchConditionInStartedGame"] = "PrematchConditionInStartedGame";
})(BetslipDisableReason || (BetslipDisableReason = {}));
const BaseBetslipContext = createContext(null);
const DetailedBetslipContext = createContext(null);
const useBaseBetslip = () => {
    return useContext(BaseBetslipContext);
};
const useDetailedBetslip = () => {
    return useContext(DetailedBetslipContext);
};
const BetslipProvider = (props) => {
    const { children, isBatchBetWithSameGameEnabled } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const { appChain } = useChain();
    const [items, setItems] = useState([]);
    const [betAmount, setBetAmount] = useState('');
    const [batchBetAmounts, setBatchBetAmounts] = useState({});
    const [isBatch, setBatch] = useState(false);
    const { odds, totalOdds, maxBet, loading: isOddsFetching } = useOdds({ betAmount, batchBetAmounts, selections: items });
    const { statuses, loading: isStatusesFetching } = useStatuses({ selections: items });
    const isCombo = !isBatch && items.length > 1;
    const checkDifferentGames = (items) => {
        const gameIds = items.map(({ game }) => game.gameId);
        return gameIds.length === new Set(gameIds).size;
    };
    const createInitialBatchAmounts = (items) => {
        setBatchBetAmounts(batchAmounts => {
            const newBatchAmounts = { ...batchAmounts };
            items.forEach(({ conditionId, outcomeId }) => {
                const key = `${conditionId}-${outcomeId}`;
                if (typeof newBatchAmounts[key] === 'undefined') {
                    newBatchAmounts[key] = '';
                }
            });
            return newBatchAmounts;
        });
    };
    const totalBetAmount = useMemo(() => {
        if (isBatch) {
            return String(Object.values(batchBetAmounts).reduce((acc, amount) => acc + +amount, 0));
        }
        return betAmount;
    }, [isBatch, betAmount, batchBetAmounts]);
    const isLiveBet = useMemo(() => {
        return items.some(({ coreAddress }) => coreAddress === liveHostAddress);
    }, [items]);
    const isConditionsInCreatedStatus = useMemo(() => {
        return Object.values(statuses).every(status => status === ConditionStatus$1.Created);
    }, [statuses]);
    const isComboWithDifferentGames = useMemo(() => {
        return !isCombo || checkDifferentGames(items);
    }, [isCombo, items]);
    const isBatchAllowed = !isBatch || !isLiveBet;
    const isComboAllowed = useMemo(() => {
        return !isCombo || !isLiveBet && isComboWithDifferentGames && items.every(({ isExpressForbidden }) => !isExpressForbidden);
    }, [isCombo, items]);
    const isPrematchBetAllowed = useMemo(() => {
        return items.every(({ coreAddress, game: { startsAt } }) => {
            if (coreAddress === liveHostAddress) {
                return true;
            }
            return startsAt * 1000 > Date.now();
        });
    }, [items]);
    const minBet = isLiveBet && !appChain?.testnet ? minLiveBetAmount : undefined;
    const isAmountLowerThanMaxBet = Boolean(betAmount) && typeof maxBet !== 'undefined' ? +betAmount <= maxBet : true;
    const isAmountBiggerThanMinBet = Boolean(betAmount) && typeof minBet !== 'undefined' ? +betAmount >= minBet : true;
    const isBetAllowed = (isConditionsInCreatedStatus
        && isComboAllowed
        && isBatchAllowed
        && isPrematchBetAllowed
        && isAmountLowerThanMaxBet
        && isAmountBiggerThanMinBet);
    let disableReason = undefined;
    if (!isConditionsInCreatedStatus) {
        disableReason = BetslipDisableReason.ConditionStatus;
    }
    if (!isComboAllowed) {
        if (isLiveBet) {
            disableReason = BetslipDisableReason.ComboWithLive;
        }
        else if (!isComboWithDifferentGames) {
            disableReason = BetslipDisableReason.ComboWithSameGame;
        }
        else {
            disableReason = BetslipDisableReason.ComboWithForbiddenItem;
        }
    }
    if (!isPrematchBetAllowed) {
        disableReason = BetslipDisableReason.PrematchConditionInStartedGame;
    }
    if (!isBatchAllowed) {
        disableReason = BetslipDisableReason.BatchWithLive;
    }
    if (!isAmountLowerThanMaxBet) {
        disableReason = BetslipDisableReason.BetAmountGreaterThanMaxBet;
    }
    if (!isAmountBiggerThanMinBet) {
        disableReason = BetslipDisableReason.BetAmountLowerThanMinBet;
    }
    const changeBatch = useCallback((value) => {
        setBatch(value);
        if (value) {
            setBetAmount('');
            createInitialBatchAmounts(items);
        }
        else {
            setBatchBetAmounts({});
        }
    }, [items]);
    const changeBetAmount = useCallback((value) => {
        setBetAmount(formatBetValue(value));
    }, []);
    const changeBatchBetAmount = useCallback((item, value) => {
        const { conditionId, outcomeId } = item;
        const key = `${conditionId}-${outcomeId}`;
        setBatchBetAmounts(amounts => {
            return {
                ...amounts,
                [key]: formatBetValue(value),
            };
        });
    }, []);
    const addItem = useCallback((itemProps) => {
        const { gameId, coreAddress, lpAddress } = itemProps;
        let game;
        let cache;
        let gameEntityId;
        if (coreAddress === liveHostAddress) {
            cache = liveClient.cache;
            gameEntityId = gameId;
        }
        else {
            cache = prematchClient.cache;
            gameEntityId = `${lpAddress.toLowerCase()}_${gameId}`;
        }
        game = cache.readFragment({
            id: cache.identify({ __typename: 'Game', id: gameEntityId }),
            fragment: MainGameInfoFragmentDoc,
            fragmentName: 'MainGameInfo',
        });
        if (!game) {
            return;
        }
        const { participants, startsAt: _startsAt, sport: { sportId: _sportId, slug: sportSlug, name: sportName, }, league: { name: leagueName, slug: leagueSlug, country: { name: countryName, slug: countrySlug, }, }, } = game;
        const item = {
            ...itemProps,
            game: {
                gameId,
                countryName,
                countrySlug,
                leagueName,
                leagueSlug,
                participants,
                startsAt: +_startsAt,
                sportId: +_sportId,
                sportSlug,
                sportName,
            },
        };
        setItems(items => {
            let newItems;
            const replaceIndex = items.findIndex(({ game: { gameId } }) => gameId === item.game.gameId);
            // if cart contains outcome from same game as new item
            // then replace old item
            if (replaceIndex !== -1) {
                if (isBatchBetWithSameGameEnabled) {
                    newItems = [...items, item];
                    setBatch(true);
                    createInitialBatchAmounts(newItems);
                }
                else {
                    newItems = [...items];
                    newItems[replaceIndex] = item;
                }
            }
            else {
                newItems = [...items, item];
            }
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            return newItems;
        });
    }, []);
    const removeItem = useCallback((itemProps) => {
        const { conditionId, outcomeId } = itemProps;
        setItems(items => {
            const newItems = items.filter((item) => !(item.conditionId === conditionId
                && item.outcomeId === outcomeId));
            if (newItems.length < 2) {
                setBatch(false);
                setBatchBetAmounts(batchAmounts => {
                    const lastItem = newItems[0];
                    if (lastItem) {
                        const { conditionId, outcomeId } = lastItem;
                        const amount = batchAmounts[`${conditionId}-${outcomeId}`];
                        if (amount) {
                            setBetAmount(amount);
                        }
                    }
                    return {};
                });
            }
            else {
                setBatchBetAmounts(batchAmounts => {
                    const newBatchAmounts = { ...batchAmounts };
                    delete newBatchAmounts[`${conditionId}-${outcomeId}`];
                    return newBatchAmounts;
                });
            }
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            return newItems;
        });
    }, []);
    const clear = useCallback(() => {
        setItems([]);
        setBatch(false);
        setBatchBetAmounts({});
        setBetAmount('');
        localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify([]));
    }, []);
    const prevChainId = useRef(appChain.id);
    useEffect(() => {
        if (prevChainId.current !== appChain.id) {
            clear();
            prevChainId.current = appChain.id;
        }
    }, [appChain.id]);
    useEffect(() => {
        let storedItems = JSON.parse(localStorage.getItem(localStorageKeys.betslipItems) || '[]');
        if (!Array.isArray(storedItems)) {
            return;
        }
        const isDifferentGames = checkDifferentGames(storedItems);
        if (!isDifferentGames) {
            setBatch(true);
            createInitialBatchAmounts(storedItems);
        }
        setItems(storedItems);
    }, []);
    const baseValue = useMemo(() => ({
        items,
        addItem,
        removeItem,
        clear,
    }), [
        items,
        addItem,
        removeItem,
        clear,
    ]);
    const detailedValue = useMemo(() => ({
        betAmount: totalBetAmount,
        batchBetAmounts,
        odds,
        totalOdds,
        maxBet,
        minBet,
        statuses,
        disableReason,
        changeBetAmount,
        changeBatchBetAmount,
        changeBatch,
        isBatch,
        isLiveBet,
        isStatusesFetching,
        isOddsFetching,
        isBetAllowed,
    }), [
        totalBetAmount,
        batchBetAmounts,
        odds,
        totalOdds,
        maxBet,
        minBet,
        statuses,
        disableReason,
        changeBetAmount,
        changeBatchBetAmount,
        changeBatch,
        isBatch,
        isLiveBet,
        isStatusesFetching,
        isOddsFetching,
        isBetAllowed,
    ]);
    return (jsx(BaseBetslipContext.Provider, { value: baseValue, children: jsx(DetailedBetslipContext.Provider, { value: detailedValue, children: children }) }));
};var AzuroBetContract_OrderBy;
(function (AzuroBetContract_OrderBy) {
    AzuroBetContract_OrderBy["Address"] = "address";
    AzuroBetContract_OrderBy["Core"] = "core";
    AzuroBetContract_OrderBy["Id"] = "id";
})(AzuroBetContract_OrderBy || (AzuroBetContract_OrderBy = {}));
var BetMargin_OrderBy;
(function (BetMargin_OrderBy) {
    BetMargin_OrderBy["Id"] = "id";
    BetMargin_OrderBy["Margins"] = "margins";
})(BetMargin_OrderBy || (BetMargin_OrderBy = {}));
var BetResult;
(function (BetResult) {
    BetResult["Lost"] = "Lost";
    BetResult["Won"] = "Won";
})(BetResult || (BetResult = {}));
var BetStatus$1;
(function (BetStatus) {
    BetStatus["Accepted"] = "Accepted";
    BetStatus["Canceled"] = "Canceled";
    BetStatus["Resolved"] = "Resolved";
})(BetStatus$1 || (BetStatus$1 = {}));
var BetType;
(function (BetType) {
    BetType["Express"] = "Express";
    BetType["Ordinar"] = "Ordinar";
})(BetType || (BetType = {}));
var Bet_OrderBy;
(function (Bet_OrderBy) {
    Bet_OrderBy["CanceledSubBetsCount"] = "_canceledSubBetsCount";
    Bet_OrderBy["ConditionIds"] = "_conditionIds";
    Bet_OrderBy["Conditions"] = "_conditions";
    Bet_OrderBy["Games"] = "_games";
    Bet_OrderBy["IsFreebet"] = "_isFreebet";
    Bet_OrderBy["LostSubBetsCount"] = "_lostSubBetsCount";
    Bet_OrderBy["MarginsForSettle"] = "_marginsForSettle";
    Bet_OrderBy["OddsDecimals"] = "_oddsDecimals";
    Bet_OrderBy["SubBetsCount"] = "_subBetsCount";
    Bet_OrderBy["TokenDecimals"] = "_tokenDecimals";
    Bet_OrderBy["UpdatedAt"] = "_updatedAt";
    Bet_OrderBy["WonSubBetsCount"] = "_wonSubBetsCount";
    Bet_OrderBy["Actor"] = "actor";
    Bet_OrderBy["Affiliate"] = "affiliate";
    Bet_OrderBy["Amount"] = "amount";
    Bet_OrderBy["ApproxSettledAt"] = "approxSettledAt";
    Bet_OrderBy["BetId"] = "betId";
    Bet_OrderBy["Bettor"] = "bettor";
    Bet_OrderBy["Core"] = "core";
    Bet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Bet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Bet_OrderBy["CreatedTxHash"] = "createdTxHash";
    Bet_OrderBy["Freebet"] = "freebet";
    Bet_OrderBy["Id"] = "id";
    Bet_OrderBy["IsRedeemable"] = "isRedeemable";
    Bet_OrderBy["IsRedeemed"] = "isRedeemed";
    Bet_OrderBy["Odds"] = "odds";
    Bet_OrderBy["Owner"] = "owner";
    Bet_OrderBy["Payout"] = "payout";
    Bet_OrderBy["PotentialPayout"] = "potentialPayout";
    Bet_OrderBy["RawAmount"] = "rawAmount";
    Bet_OrderBy["RawOdds"] = "rawOdds";
    Bet_OrderBy["RawPayout"] = "rawPayout";
    Bet_OrderBy["RawPotentialPayout"] = "rawPotentialPayout";
    Bet_OrderBy["RawSettledMargin"] = "rawSettledMargin";
    Bet_OrderBy["RawSettledOdds"] = "rawSettledOdds";
    Bet_OrderBy["RedeemedBlockNumber"] = "redeemedBlockNumber";
    Bet_OrderBy["RedeemedBlockTimestamp"] = "redeemedBlockTimestamp";
    Bet_OrderBy["RedeemedTxHash"] = "redeemedTxHash";
    Bet_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Bet_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Bet_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Bet_OrderBy["Result"] = "result";
    Bet_OrderBy["Selections"] = "selections";
    Bet_OrderBy["SettledMargin"] = "settledMargin";
    Bet_OrderBy["SettledOdds"] = "settledOdds";
    Bet_OrderBy["Status"] = "status";
    Bet_OrderBy["Type"] = "type";
})(Bet_OrderBy || (Bet_OrderBy = {}));
var Bettor_OrderBy;
(function (Bettor_OrderBy) {
    Bettor_OrderBy["UpdatedAt"] = "_updatedAt";
    Bettor_OrderBy["Address"] = "address";
    Bettor_OrderBy["Affiliate"] = "affiliate";
    Bettor_OrderBy["AvgBetAmount"] = "avgBetAmount";
    Bettor_OrderBy["BetsCount"] = "betsCount";
    Bettor_OrderBy["BiggestBetAmount"] = "biggestBetAmount";
    Bettor_OrderBy["BiggestPayout"] = "biggestPayout";
    Bettor_OrderBy["CanceledBetsCount"] = "canceledBetsCount";
    Bettor_OrderBy["ExpressBetsCount"] = "expressBetsCount";
    Bettor_OrderBy["FirstBetTimestamp"] = "firstBetTimestamp";
    Bettor_OrderBy["Id"] = "id";
    Bettor_OrderBy["InBets"] = "inBets";
    Bettor_OrderBy["LastBetTimestamp"] = "lastBetTimestamp";
    Bettor_OrderBy["LiveBetsCount"] = "liveBetsCount";
    Bettor_OrderBy["LostBetsCount"] = "lostBetsCount";
    Bettor_OrderBy["Pnl"] = "pnl";
    Bettor_OrderBy["PrematchBetsCount"] = "prematchBetsCount";
    Bettor_OrderBy["RawAvgBetAmount"] = "rawAvgBetAmount";
    Bettor_OrderBy["RawBiggestBetAmount"] = "rawBiggestBetAmount";
    Bettor_OrderBy["RawBiggestPayout"] = "rawBiggestPayout";
    Bettor_OrderBy["RawInBets"] = "rawInBets";
    Bettor_OrderBy["RawToPayout"] = "rawToPayout";
    Bettor_OrderBy["RawTotalPayout"] = "rawTotalPayout";
    Bettor_OrderBy["RawTotalProfit"] = "rawTotalProfit";
    Bettor_OrderBy["RawTurnover"] = "rawTurnover";
    Bettor_OrderBy["RedeemedBetsCount"] = "redeemedBetsCount";
    Bettor_OrderBy["SettledBetsCount"] = "settledBetsCount";
    Bettor_OrderBy["ToPayout"] = "toPayout";
    Bettor_OrderBy["TotalPayout"] = "totalPayout";
    Bettor_OrderBy["TotalProfit"] = "totalProfit";
    Bettor_OrderBy["Turnover"] = "turnover";
    Bettor_OrderBy["WonBetsCount"] = "wonBetsCount";
})(Bettor_OrderBy || (Bettor_OrderBy = {}));
var ConditionStatus;
(function (ConditionStatus) {
    ConditionStatus["Canceled"] = "Canceled";
    ConditionStatus["Created"] = "Created";
    ConditionStatus["Paused"] = "Paused";
    ConditionStatus["Resolved"] = "Resolved";
})(ConditionStatus || (ConditionStatus = {}));
var Condition_OrderBy;
(function (Condition_OrderBy) {
    Condition_OrderBy["UpdatedAt"] = "_updatedAt";
    Condition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    Condition_OrderBy["ConditionId"] = "conditionId";
    Condition_OrderBy["Core"] = "core";
    Condition_OrderBy["CoreAddress"] = "coreAddress";
    Condition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Condition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Condition_OrderBy["CreatedTxHash"] = "createdTxHash";
    Condition_OrderBy["Game"] = "game";
    Condition_OrderBy["Id"] = "id";
    Condition_OrderBy["InternalStartsAt"] = "internalStartsAt";
    Condition_OrderBy["IsExpressForbidden"] = "isExpressForbidden";
    Condition_OrderBy["Margin"] = "margin";
    Condition_OrderBy["Outcomes"] = "outcomes";
    Condition_OrderBy["OutcomesIds"] = "outcomesIds";
    Condition_OrderBy["Provider"] = "provider";
    Condition_OrderBy["Reinforcement"] = "reinforcement";
    Condition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Condition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Condition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Condition_OrderBy["Status"] = "status";
    Condition_OrderBy["Turnover"] = "turnover";
    Condition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    Condition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(Condition_OrderBy || (Condition_OrderBy = {}));
var CoreContract_OrderBy;
(function (CoreContract_OrderBy) {
    CoreContract_OrderBy["Address"] = "address";
    CoreContract_OrderBy["Id"] = "id";
    CoreContract_OrderBy["LiquidityPool"] = "liquidityPool";
    CoreContract_OrderBy["Type"] = "type";
})(CoreContract_OrderBy || (CoreContract_OrderBy = {}));
var Country_OrderBy;
(function (Country_OrderBy) {
    Country_OrderBy["ActiveLeaguesEntityIds"] = "activeLeaguesEntityIds";
    Country_OrderBy["HasActiveLeagues"] = "hasActiveLeagues";
    Country_OrderBy["Id"] = "id";
    Country_OrderBy["Leagues"] = "leagues";
    Country_OrderBy["Name"] = "name";
    Country_OrderBy["Slug"] = "slug";
    Country_OrderBy["Sport"] = "sport";
    Country_OrderBy["Turnover"] = "turnover";
})(Country_OrderBy || (Country_OrderBy = {}));
var EventName;
(function (EventName) {
    EventName["AzuroBetTransfer"] = "AzuroBetTransfer";
    EventName["BetSettled"] = "BetSettled";
    EventName["BettorWin"] = "BettorWin";
    EventName["ConditionCreated"] = "ConditionCreated";
    EventName["ConditionResolved"] = "ConditionResolved";
    EventName["ConditionShifted"] = "ConditionShifted";
    EventName["ConditionStopped"] = "ConditionStopped";
    EventName["FreeBetBettorWin"] = "FreeBetBettorWin";
    EventName["FreeBetMinted"] = "FreeBetMinted";
    EventName["FreeBetRedeemed"] = "FreeBetRedeemed";
    EventName["FreeBetReissued"] = "FreeBetReissued";
    EventName["FreeBetTransfer"] = "FreeBetTransfer";
    EventName["GameShifted"] = "GameShifted";
    EventName["LiquidityAdded"] = "LiquidityAdded";
    EventName["LiquidityRemoved"] = "LiquidityRemoved";
    EventName["LiquidityTransfer"] = "LiquidityTransfer";
    EventName["LiveBetSettled"] = "LiveBetSettled";
    EventName["MarginChanged"] = "MarginChanged";
    EventName["NewBet"] = "NewBet";
    EventName["NewGame"] = "NewGame";
    EventName["NewLiveBet"] = "NewLiveBet";
    EventName["ReinforcementChanged"] = "ReinforcementChanged";
})(EventName || (EventName = {}));
var Event_OrderBy;
(function (Event_OrderBy) {
    Event_OrderBy["Affiliate"] = "affiliate";
    Event_OrderBy["BetId"] = "betId";
    Event_OrderBy["BlockNumber"] = "blockNumber";
    Event_OrderBy["BlockTimestamp"] = "blockTimestamp";
    Event_OrderBy["ConditionId"] = "conditionId";
    Event_OrderBy["ContractAddress"] = "contractAddress";
    Event_OrderBy["DepositId"] = "depositId";
    Event_OrderBy["FreebetId"] = "freebetId";
    Event_OrderBy["GameId"] = "gameId";
    Event_OrderBy["GasPrice"] = "gasPrice";
    Event_OrderBy["GasUsed"] = "gasUsed";
    Event_OrderBy["Id"] = "id";
    Event_OrderBy["LogIndex"] = "logIndex";
    Event_OrderBy["Name"] = "name";
    Event_OrderBy["SortOrder"] = "sortOrder";
    Event_OrderBy["TransactionIndex"] = "transactionIndex";
    Event_OrderBy["TxHash"] = "txHash";
})(Event_OrderBy || (Event_OrderBy = {}));
var ExpressPrematchRelation_OrderBy;
(function (ExpressPrematchRelation_OrderBy) {
    ExpressPrematchRelation_OrderBy["Id"] = "id";
    ExpressPrematchRelation_OrderBy["PrematchAddress"] = "prematchAddress";
})(ExpressPrematchRelation_OrderBy || (ExpressPrematchRelation_OrderBy = {}));
var FreebetContract_OrderBy;
(function (FreebetContract_OrderBy) {
    FreebetContract_OrderBy["Address"] = "address";
    FreebetContract_OrderBy["Affiliate"] = "affiliate";
    FreebetContract_OrderBy["Id"] = "id";
    FreebetContract_OrderBy["LiquidityPool"] = "liquidityPool";
    FreebetContract_OrderBy["Manager"] = "manager";
    FreebetContract_OrderBy["Name"] = "name";
})(FreebetContract_OrderBy || (FreebetContract_OrderBy = {}));
var FreebetStatus;
(function (FreebetStatus) {
    FreebetStatus["Created"] = "Created";
    FreebetStatus["Redeemed"] = "Redeemed";
    FreebetStatus["Reissued"] = "Reissued";
    FreebetStatus["Withdrawn"] = "Withdrawn";
})(FreebetStatus || (FreebetStatus = {}));
var Freebet_OrderBy;
(function (Freebet_OrderBy) {
    Freebet_OrderBy["UpdatedAt"] = "_updatedAt";
    Freebet_OrderBy["Amount"] = "amount";
    Freebet_OrderBy["AzuroBetId"] = "azuroBetId";
    Freebet_OrderBy["Burned"] = "burned";
    Freebet_OrderBy["Core"] = "core";
    Freebet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Freebet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Freebet_OrderBy["CreatedTxHash"] = "createdTxHash";
    Freebet_OrderBy["DurationTime"] = "durationTime";
    Freebet_OrderBy["ExpiresAt"] = "expiresAt";
    Freebet_OrderBy["Freebet"] = "freebet";
    Freebet_OrderBy["FreebetContractAddress"] = "freebetContractAddress";
    Freebet_OrderBy["FreebetContractAffiliate"] = "freebetContractAffiliate";
    Freebet_OrderBy["FreebetContractName"] = "freebetContractName";
    Freebet_OrderBy["FreebetId"] = "freebetId";
    Freebet_OrderBy["Id"] = "id";
    Freebet_OrderBy["IsResolved"] = "isResolved";
    Freebet_OrderBy["MinOdds"] = "minOdds";
    Freebet_OrderBy["Owner"] = "owner";
    Freebet_OrderBy["RawAmount"] = "rawAmount";
    Freebet_OrderBy["RawMinOdds"] = "rawMinOdds";
    Freebet_OrderBy["Status"] = "status";
    Freebet_OrderBy["TokenDecimals"] = "tokenDecimals";
})(Freebet_OrderBy || (Freebet_OrderBy = {}));
var GameStatus$1;
(function (GameStatus) {
    GameStatus["Canceled"] = "Canceled";
    GameStatus["Created"] = "Created";
    GameStatus["Paused"] = "Paused";
    GameStatus["Resolved"] = "Resolved";
})(GameStatus$1 || (GameStatus$1 = {}));
var Game_OrderBy;
(function (Game_OrderBy) {
    Game_OrderBy["ActiveConditionsEntityIds"] = "_activeConditionsEntityIds";
    Game_OrderBy["CanceledConditionsEntityIds"] = "_canceledConditionsEntityIds";
    Game_OrderBy["PausedConditionsEntityIds"] = "_pausedConditionsEntityIds";
    Game_OrderBy["ResolvedConditionsEntityIds"] = "_resolvedConditionsEntityIds";
    Game_OrderBy["UpdatedAt"] = "_updatedAt";
    Game_OrderBy["Conditions"] = "conditions";
    Game_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Game_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Game_OrderBy["CreatedTxHash"] = "createdTxHash";
    Game_OrderBy["GameId"] = "gameId";
    Game_OrderBy["HasActiveConditions"] = "hasActiveConditions";
    Game_OrderBy["Id"] = "id";
    Game_OrderBy["League"] = "league";
    Game_OrderBy["LiquidityPool"] = "liquidityPool";
    Game_OrderBy["Participants"] = "participants";
    Game_OrderBy["Provider"] = "provider";
    Game_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Game_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Game_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Game_OrderBy["ShiftedBlockNumber"] = "shiftedBlockNumber";
    Game_OrderBy["ShiftedBlockTimestamp"] = "shiftedBlockTimestamp";
    Game_OrderBy["ShiftedTxHash"] = "shiftedTxHash";
    Game_OrderBy["Slug"] = "slug";
    Game_OrderBy["Sport"] = "sport";
    Game_OrderBy["StartsAt"] = "startsAt";
    Game_OrderBy["Status"] = "status";
    Game_OrderBy["Title"] = "title";
    Game_OrderBy["Turnover"] = "turnover";
})(Game_OrderBy || (Game_OrderBy = {}));
var League_OrderBy;
(function (League_OrderBy) {
    League_OrderBy["ActiveGamesEntityIds"] = "activeGamesEntityIds";
    League_OrderBy["Country"] = "country";
    League_OrderBy["Games"] = "games";
    League_OrderBy["HasActiveGames"] = "hasActiveGames";
    League_OrderBy["Id"] = "id";
    League_OrderBy["Name"] = "name";
    League_OrderBy["Slug"] = "slug";
    League_OrderBy["Turnover"] = "turnover";
})(League_OrderBy || (League_OrderBy = {}));
var LiquidityPoolContractType;
(function (LiquidityPoolContractType) {
    LiquidityPoolContractType["V1"] = "V1";
    LiquidityPoolContractType["V2"] = "V2";
})(LiquidityPoolContractType || (LiquidityPoolContractType = {}));
var LiquidityPoolContract_OrderBy;
(function (LiquidityPoolContract_OrderBy) {
    LiquidityPoolContract_OrderBy["Address"] = "address";
    LiquidityPoolContract_OrderBy["Apr"] = "apr";
    LiquidityPoolContract_OrderBy["Asset"] = "asset";
    LiquidityPoolContract_OrderBy["BetsAmount"] = "betsAmount";
    LiquidityPoolContract_OrderBy["BetsCount"] = "betsCount";
    LiquidityPoolContract_OrderBy["ChainId"] = "chainId";
    LiquidityPoolContract_OrderBy["ChainName"] = "chainName";
    LiquidityPoolContract_OrderBy["CoreAddresses"] = "coreAddresses";
    LiquidityPoolContract_OrderBy["Cores"] = "cores";
    LiquidityPoolContract_OrderBy["DaysSinceDeployment"] = "daysSinceDeployment";
    LiquidityPoolContract_OrderBy["DepositedAmount"] = "depositedAmount";
    LiquidityPoolContract_OrderBy["DepositedWithStakingAmount"] = "depositedWithStakingAmount";
    LiquidityPoolContract_OrderBy["FirstCalculatedBlockNumber"] = "firstCalculatedBlockNumber";
    LiquidityPoolContract_OrderBy["FirstCalculatedBlockTimestamp"] = "firstCalculatedBlockTimestamp";
    LiquidityPoolContract_OrderBy["Id"] = "id";
    LiquidityPoolContract_OrderBy["LastCalculatedBlockNumber"] = "lastCalculatedBlockNumber";
    LiquidityPoolContract_OrderBy["LastCalculatedBlockTimestamp"] = "lastCalculatedBlockTimestamp";
    LiquidityPoolContract_OrderBy["LiquidityManager"] = "liquidityManager";
    LiquidityPoolContract_OrderBy["Nfts"] = "nfts";
    LiquidityPoolContract_OrderBy["RawApr"] = "rawApr";
    LiquidityPoolContract_OrderBy["RawTvl"] = "rawTvl";
    LiquidityPoolContract_OrderBy["Token"] = "token";
    LiquidityPoolContract_OrderBy["TokenDecimals"] = "tokenDecimals";
    LiquidityPoolContract_OrderBy["Tvl"] = "tvl";
    LiquidityPoolContract_OrderBy["Type"] = "type";
    LiquidityPoolContract_OrderBy["WithdrawTimeout"] = "withdrawTimeout";
    LiquidityPoolContract_OrderBy["WithdrawnAmount"] = "withdrawnAmount";
    LiquidityPoolContract_OrderBy["WithdrawnWithStakingAmount"] = "withdrawnWithStakingAmount";
    LiquidityPoolContract_OrderBy["WonBetsAmount"] = "wonBetsAmount";
    LiquidityPoolContract_OrderBy["WonBetsCount"] = "wonBetsCount";
})(LiquidityPoolContract_OrderBy || (LiquidityPoolContract_OrderBy = {}));
var LiquidityPoolNft_OrderBy;
(function (LiquidityPoolNft_OrderBy) {
    LiquidityPoolNft_OrderBy["CreateBlockNumber"] = "createBlockNumber";
    LiquidityPoolNft_OrderBy["CreateBlockTimestamp"] = "createBlockTimestamp";
    LiquidityPoolNft_OrderBy["DepositedAmount"] = "depositedAmount";
    LiquidityPoolNft_OrderBy["HistoricalOwners"] = "historicalOwners";
    LiquidityPoolNft_OrderBy["Id"] = "id";
    LiquidityPoolNft_OrderBy["IsFullyWithdrawn"] = "isFullyWithdrawn";
    LiquidityPoolNft_OrderBy["LiquidityPool"] = "liquidityPool";
    LiquidityPoolNft_OrderBy["NftId"] = "nftId";
    LiquidityPoolNft_OrderBy["Owner"] = "owner";
    LiquidityPoolNft_OrderBy["RawDepositedAmount"] = "rawDepositedAmount";
    LiquidityPoolNft_OrderBy["RawWithdrawnAmount"] = "rawWithdrawnAmount";
    LiquidityPoolNft_OrderBy["Transactions"] = "transactions";
    LiquidityPoolNft_OrderBy["WithdrawTimeout"] = "withdrawTimeout";
    LiquidityPoolNft_OrderBy["WithdrawnAmount"] = "withdrawnAmount";
})(LiquidityPoolNft_OrderBy || (LiquidityPoolNft_OrderBy = {}));
var LiquidityPoolTransactionType;
(function (LiquidityPoolTransactionType) {
    LiquidityPoolTransactionType["Deposit"] = "Deposit";
    LiquidityPoolTransactionType["Withdrawal"] = "Withdrawal";
})(LiquidityPoolTransactionType || (LiquidityPoolTransactionType = {}));
var LiquidityPoolTransaction_OrderBy;
(function (LiquidityPoolTransaction_OrderBy) {
    LiquidityPoolTransaction_OrderBy["Account"] = "account";
    LiquidityPoolTransaction_OrderBy["Amount"] = "amount";
    LiquidityPoolTransaction_OrderBy["BlockNumber"] = "blockNumber";
    LiquidityPoolTransaction_OrderBy["BlockTimestamp"] = "blockTimestamp";
    LiquidityPoolTransaction_OrderBy["Id"] = "id";
    LiquidityPoolTransaction_OrderBy["LiquidityPool"] = "liquidityPool";
    LiquidityPoolTransaction_OrderBy["Nft"] = "nft";
    LiquidityPoolTransaction_OrderBy["RawAmount"] = "rawAmount";
    LiquidityPoolTransaction_OrderBy["TxHash"] = "txHash";
    LiquidityPoolTransaction_OrderBy["Type"] = "type";
})(LiquidityPoolTransaction_OrderBy || (LiquidityPoolTransaction_OrderBy = {}));
var LiveBet_OrderBy;
(function (LiveBet_OrderBy) {
    LiveBet_OrderBy["CanceledSubBetsCount"] = "_canceledSubBetsCount";
    LiveBet_OrderBy["ConditionIds"] = "_conditionIds";
    LiveBet_OrderBy["Conditions"] = "_conditions";
    LiveBet_OrderBy["GamesIds"] = "_gamesIds";
    LiveBet_OrderBy["IsFreebet"] = "_isFreebet";
    LiveBet_OrderBy["LostSubBetsCount"] = "_lostSubBetsCount";
    LiveBet_OrderBy["MarginsForSettle"] = "_marginsForSettle";
    LiveBet_OrderBy["OddsDecimals"] = "_oddsDecimals";
    LiveBet_OrderBy["SubBetsCount"] = "_subBetsCount";
    LiveBet_OrderBy["TokenDecimals"] = "_tokenDecimals";
    LiveBet_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveBet_OrderBy["WonSubBetsCount"] = "_wonSubBetsCount";
    LiveBet_OrderBy["Actor"] = "actor";
    LiveBet_OrderBy["Affiliate"] = "affiliate";
    LiveBet_OrderBy["Amount"] = "amount";
    LiveBet_OrderBy["BetId"] = "betId";
    LiveBet_OrderBy["Bettor"] = "bettor";
    LiveBet_OrderBy["Core"] = "core";
    LiveBet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    LiveBet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    LiveBet_OrderBy["CreatedTxHash"] = "createdTxHash";
    LiveBet_OrderBy["Freebet"] = "freebet";
    LiveBet_OrderBy["Id"] = "id";
    LiveBet_OrderBy["IsRedeemable"] = "isRedeemable";
    LiveBet_OrderBy["IsRedeemed"] = "isRedeemed";
    LiveBet_OrderBy["Nonce"] = "nonce";
    LiveBet_OrderBy["Odds"] = "odds";
    LiveBet_OrderBy["Owner"] = "owner";
    LiveBet_OrderBy["Payout"] = "payout";
    LiveBet_OrderBy["PayoutLimit"] = "payoutLimit";
    LiveBet_OrderBy["PotentialPayout"] = "potentialPayout";
    LiveBet_OrderBy["RawAmount"] = "rawAmount";
    LiveBet_OrderBy["RawOdds"] = "rawOdds";
    LiveBet_OrderBy["RawPayout"] = "rawPayout";
    LiveBet_OrderBy["RawPayoutLimit"] = "rawPayoutLimit";
    LiveBet_OrderBy["RawPotentialPayout"] = "rawPotentialPayout";
    LiveBet_OrderBy["RawSettledMargin"] = "rawSettledMargin";
    LiveBet_OrderBy["RawSettledOdds"] = "rawSettledOdds";
    LiveBet_OrderBy["RedeemedBlockNumber"] = "redeemedBlockNumber";
    LiveBet_OrderBy["RedeemedBlockTimestamp"] = "redeemedBlockTimestamp";
    LiveBet_OrderBy["RedeemedTxHash"] = "redeemedTxHash";
    LiveBet_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    LiveBet_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    LiveBet_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    LiveBet_OrderBy["Result"] = "result";
    LiveBet_OrderBy["Selections"] = "selections";
    LiveBet_OrderBy["SettledMargin"] = "settledMargin";
    LiveBet_OrderBy["SettledOdds"] = "settledOdds";
    LiveBet_OrderBy["Status"] = "status";
})(LiveBet_OrderBy || (LiveBet_OrderBy = {}));
var LiveCondition_OrderBy;
(function (LiveCondition_OrderBy) {
    LiveCondition_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveCondition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    LiveCondition_OrderBy["ConditionId"] = "conditionId";
    LiveCondition_OrderBy["Core"] = "core";
    LiveCondition_OrderBy["CoreAddress"] = "coreAddress";
    LiveCondition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    LiveCondition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    LiveCondition_OrderBy["CreatedTxHash"] = "createdTxHash";
    LiveCondition_OrderBy["GameId"] = "gameId";
    LiveCondition_OrderBy["Id"] = "id";
    LiveCondition_OrderBy["Outcomes"] = "outcomes";
    LiveCondition_OrderBy["OutcomesIds"] = "outcomesIds";
    LiveCondition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    LiveCondition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    LiveCondition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    LiveCondition_OrderBy["Status"] = "status";
    LiveCondition_OrderBy["Turnover"] = "turnover";
    LiveCondition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    LiveCondition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(LiveCondition_OrderBy || (LiveCondition_OrderBy = {}));
var LiveOutcome_OrderBy;
(function (LiveOutcome_OrderBy) {
    LiveOutcome_OrderBy["BetsEntityIds"] = "_betsEntityIds";
    LiveOutcome_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveOutcome_OrderBy["Condition"] = "condition";
    LiveOutcome_OrderBy["Core"] = "core";
    LiveOutcome_OrderBy["Id"] = "id";
    LiveOutcome_OrderBy["OutcomeId"] = "outcomeId";
    LiveOutcome_OrderBy["Result"] = "result";
    LiveOutcome_OrderBy["Selections"] = "selections";
    LiveOutcome_OrderBy["SortOrder"] = "sortOrder";
})(LiveOutcome_OrderBy || (LiveOutcome_OrderBy = {}));
var LiveSelection_OrderBy;
(function (LiveSelection_OrderBy) {
    LiveSelection_OrderBy["OddsDecimals"] = "_oddsDecimals";
    LiveSelection_OrderBy["OutcomeId"] = "_outcomeId";
    LiveSelection_OrderBy["Bet"] = "bet";
    LiveSelection_OrderBy["Id"] = "id";
    LiveSelection_OrderBy["Margin"] = "margin";
    LiveSelection_OrderBy["Odds"] = "odds";
    LiveSelection_OrderBy["Outcome"] = "outcome";
    LiveSelection_OrderBy["RawMargin"] = "rawMargin";
    LiveSelection_OrderBy["RawOdds"] = "rawOdds";
    LiveSelection_OrderBy["Result"] = "result";
})(LiveSelection_OrderBy || (LiveSelection_OrderBy = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
var OutcomeResult;
(function (OutcomeResult) {
    OutcomeResult["Lost"] = "Lost";
    OutcomeResult["Won"] = "Won";
})(OutcomeResult || (OutcomeResult = {}));
var Outcome_OrderBy;
(function (Outcome_OrderBy) {
    Outcome_OrderBy["BetsEntityIds"] = "_betsEntityIds";
    Outcome_OrderBy["UpdatedAt"] = "_updatedAt";
    Outcome_OrderBy["Condition"] = "condition";
    Outcome_OrderBy["Core"] = "core";
    Outcome_OrderBy["CurrentOdds"] = "currentOdds";
    Outcome_OrderBy["Fund"] = "fund";
    Outcome_OrderBy["Id"] = "id";
    Outcome_OrderBy["OutcomeId"] = "outcomeId";
    Outcome_OrderBy["RawCurrentOdds"] = "rawCurrentOdds";
    Outcome_OrderBy["Result"] = "result";
    Outcome_OrderBy["Selections"] = "selections";
    Outcome_OrderBy["SortOrder"] = "sortOrder";
})(Outcome_OrderBy || (Outcome_OrderBy = {}));
var Participant_OrderBy;
(function (Participant_OrderBy) {
    Participant_OrderBy["Game"] = "game";
    Participant_OrderBy["Id"] = "id";
    Participant_OrderBy["Image"] = "image";
    Participant_OrderBy["Name"] = "name";
    Participant_OrderBy["SortOrder"] = "sortOrder";
})(Participant_OrderBy || (Participant_OrderBy = {}));
var SelectionResult;
(function (SelectionResult) {
    SelectionResult["Lost"] = "Lost";
    SelectionResult["Won"] = "Won";
})(SelectionResult || (SelectionResult = {}));
var Selection_OrderBy;
(function (Selection_OrderBy) {
    Selection_OrderBy["OddsDecimals"] = "_oddsDecimals";
    Selection_OrderBy["OutcomeId"] = "_outcomeId";
    Selection_OrderBy["Bet"] = "bet";
    Selection_OrderBy["Id"] = "id";
    Selection_OrderBy["Margin"] = "margin";
    Selection_OrderBy["Odds"] = "odds";
    Selection_OrderBy["Outcome"] = "outcome";
    Selection_OrderBy["RawMargin"] = "rawMargin";
    Selection_OrderBy["RawOdds"] = "rawOdds";
    Selection_OrderBy["Result"] = "result";
})(Selection_OrderBy || (Selection_OrderBy = {}));
var SportHub_OrderBy;
(function (SportHub_OrderBy) {
    SportHub_OrderBy["Id"] = "id";
    SportHub_OrderBy["Name"] = "name";
    SportHub_OrderBy["Slug"] = "slug";
    SportHub_OrderBy["Sports"] = "sports";
})(SportHub_OrderBy || (SportHub_OrderBy = {}));
var Sport_OrderBy;
(function (Sport_OrderBy) {
    Sport_OrderBy["Countries"] = "countries";
    Sport_OrderBy["Games"] = "games";
    Sport_OrderBy["Id"] = "id";
    Sport_OrderBy["Name"] = "name";
    Sport_OrderBy["Slug"] = "slug";
    Sport_OrderBy["SportId"] = "sportId";
    Sport_OrderBy["Sporthub"] = "sporthub";
})(Sport_OrderBy || (Sport_OrderBy = {}));
var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (_SubgraphErrorPolicy_ = {}));const useWatchers = () => {
    const { appChain, contracts } = useChain();
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'NewBet',
        chainId: appChain.id,
        onLogs(logs) {
            const log = logs[0];
            const conditionId = log.args.conditionId;
            oddsWatcher.dispatch(conditionId.toString());
        },
    });
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'OddsChanged',
        chainId: appChain.id,
        onLogs(logs) {
            const log = logs[0];
            const conditionId = log.args.conditionId;
            oddsWatcher.dispatch(conditionId.toString());
        },
    });
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'ConditionStopped',
        chainId: appChain.id,
        onLogs(logs) {
            const log = logs[0];
            const conditionId = log.args.conditionId;
            const isStopped = log.args.flag;
            const status = isStopped ? ConditionStatus.Paused : ConditionStatus.Created;
            conditionStatusWatcher.dispatch(conditionId.toString(), status);
        },
    });
};function Watchers() {
    useWatchers();
    return null;
}
const AzuroSDKProvider = ({ children, initialChainId, isBatchBetWithSameGameEnabled }) => {
    return (jsx(ChainProvider, { initialChainId: initialChainId, children: jsxs(SocketProvider, { children: [jsx(ApolloProvider, { children: jsx(BetslipProvider, { isBatchBetWithSameGameEnabled: isBatchBetWithSameGameEnabled, children: children }) }), jsx(Watchers, {})] }) }));
};const LiveContext = createContext(null);
const useLive = () => {
    return useContext(LiveContext);
};
const LiveProvider = (props) => {
    const { children, initialLiveState } = props;
    const { appChain, setAppChainId } = useChain();
    const [isLive, setLive] = useState(liveSupportedChains.includes(appChain.id) && Boolean(initialLiveState));
    useMemo(() => {
        if (!liveSupportedChains.includes(appChain.id) && isLive) {
            setLive(false);
            document.cookie = `${cookieKeys.live}=false;path=/;`;
        }
    }, [appChain]);
    const handleChangeLive = (value) => {
        document.cookie = `${cookieKeys.live}=${value};path=/;`;
        if (value && !liveSupportedChains.includes(appChain.id)) {
            setAppChainId(liveSupportedChains[0]);
        }
        setLive(value);
    };
    const value = {
        isLive,
        changeLive: handleChangeLive,
    };
    return (jsx(LiveContext.Provider, { value: value, children: children }));
};const GamesDocument = gql `
    query Games($first: Int, $skip: Int, $where: Game_filter!, $orderBy: Game_orderBy, $orderDirection: OrderDirection) {
  games(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...MainGameInfo
  }
}
    ${MainGameInfoFragmentDoc}`;const GameDocument = gql `
    query Game($gameId: BigInt!) {
  games(where: {gameId: $gameId}) {
    ...MainGameInfo
  }
}
    ${MainGameInfoFragmentDoc}`;const SportsDocument = gql `
    query Sports($first: Int, $sportFilter: Sport_filter, $countryFilter: Country_filter, $leagueFilter: League_filter, $gameFilter: Game_filter, $gameOrderBy: Game_orderBy, $gameOrderDirection: OrderDirection) {
  sports(where: $sportFilter, subgraphError: allow) {
    slug
    name
    countries(where: $countryFilter, orderBy: turnover, orderDirection: desc) {
      slug
      name
      turnover
      leagues(where: $leagueFilter, orderBy: turnover, orderDirection: desc) {
        slug
        name
        turnover
        games(
          where: $gameFilter
          first: $first
          orderBy: $gameOrderBy
          orderDirection: $gameOrderDirection
        ) {
          turnover
          ...MainGameInfo
        }
      }
    }
  }
}
    ${MainGameInfoFragmentDoc}`;const BetFragmentDoc = gql `
    fragment Bet on Bet {
  id
  tokenId: betId
  amount
  status
  potentialPayout
  payout
  result
  isRedeemed
  isRedeemable
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  txHash: createdTxHash
  affiliate
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      condition {
        conditionId
        status
        game {
          ...MainGameInfo
        }
      }
    }
  }
  freebet {
    freebetId
    contractAddress: freebetContractAddress
  }
}
    ${MainGameInfoFragmentDoc}`;const BetsDocument = gql `
    query Bets($first: Int, $skip: Int, $where: Bet_filter!, $orderBy: Bet_orderBy, $orderDirection: OrderDirection) {
  bets(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...Bet
  }
}
    ${BetFragmentDoc}`;const LiveBetFragmentDoc = gql `
    fragment LiveBet on LiveBet {
  id
  tokenId: betId
  amount
  status
  potentialPayout
  payout
  result
  isRedeemed
  isRedeemable
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  txHash: createdTxHash
  affiliate
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      condition {
        conditionId
        status
        gameId
      }
    }
  }
}
    `;const LiveBetsDocument = gql `
    query LiveBets($first: Int, $skip: Int, $where: Bet_filter!, $orderBy: Bet_orderBy, $orderDirection: OrderDirection) {
  liveBets(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...LiveBet
  }
}
    ${LiveBetFragmentDoc}`;const ConditionFragmentDoc$1 = gql `
    fragment Condition on Condition {
  id
  conditionId
  status
  isExpressForbidden
  outcomes {
    outcomeId
    odds: currentOdds
  }
  core {
    address
    liquidityPool {
      address
    }
  }
  game {
    gameId
    sport {
      sportId
    }
  }
}
    `;const ConditionsDocument$1 = gql `
    query Conditions($where: Condition_filter!) {
  conditions(where: $where, first: 1000, subgraphError: allow) {
    ...Condition
  }
}
    ${ConditionFragmentDoc$1}`;const NavigationDocument = gql `
    query Navigation($first: Int, $where: Game_filter, $withGameCount: Boolean!) {
  sports {
    id
    slug
    name
    games(first: $first, where: $where) @include(if: $withGameCount) {
      id
    }
  }
}
    `;const calcMindOdds = (props) => {
    const totalOdds = typeof props.odds === 'number' ? props.odds : props.odds.reduce((acc, odds) => acc * +odds, 1);
    const minOdds = 1 + (totalOdds - 1) * (100 - props.slippage) / 100;
    return minOdds.toFixed(ODDS_DECIMALS);
};const setGamesCacheTime = (cacheTime) => {
    configRef.gamesCacheTime = cacheTime;
};const getPrematchBetDataBytes = (selections) => {
    if (selections.length > 1) {
        const tuple = selections.map(({ conditionId, outcomeId }) => [
            BigInt(conditionId),
            BigInt(outcomeId),
        ]);
        return encodeAbiParameters(parseAbiParameters('(uint256, uint64)[]'), [
            tuple,
        ]);
    }
    const { conditionId, outcomeId } = selections[0];
    return encodeAbiParameters(parseAbiParameters('uint256, uint64'), [
        BigInt(conditionId),
        BigInt(outcomeId),
    ]);
};const getIsPendingResolution = (startDate) => {
    const now = Date.now();
    const isStarted = startDate < now;
    const pendingResolutionDate = startDate + 6000000;
    return isStarted && pendingResolutionDate < now;
};
var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["Created"] = 0] = "Created";
    GameStatus[GameStatus["Live"] = 1] = "Live";
    GameStatus[GameStatus["Resolved"] = 2] = "Resolved";
    GameStatus[GameStatus["Canceled"] = 3] = "Canceled";
    GameStatus[GameStatus["Paused"] = 4] = "Paused";
    GameStatus[GameStatus["PendingResolution"] = 5] = "PendingResolution";
})(GameStatus || (GameStatus = {}));
const getGameStatus = (props) => {
    const { graphStatus, startsAt, isGameInLive } = props;
    const startDate = startsAt * 1000;
    const isStarted = startDate < Date.now();
    // we use LiveGameStatus enum for conditions because it contains PrematchGameStatus
    if (graphStatus === GameStatus$2.Canceled) {
        return GameStatus.Canceled;
    }
    if (graphStatus === GameStatus$2.Paused) {
        return GameStatus.Paused;
    }
    if (graphStatus === GameStatus$2.Resolved) {
        return GameStatus.Resolved;
    }
    if (graphStatus === GameStatus$2.Finished) {
        return GameStatus.PendingResolution;
    }
    if (isStarted) {
        if (!isGameInLive && getIsPendingResolution(startDate)) {
            return GameStatus.PendingResolution;
        }
        return GameStatus.Live;
    }
    return GameStatus.Created;
};var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["Accepted"] = 0] = "Accepted";
    BetStatus[BetStatus["Live"] = 1] = "Live";
    BetStatus[BetStatus["PendingResolution"] = 2] = "PendingResolution";
    BetStatus[BetStatus["Resolved"] = 3] = "Resolved";
    BetStatus[BetStatus["Canceled"] = 4] = "Canceled";
})(BetStatus || (BetStatus = {}));
const getExpressIsLive = (games) => {
    const firstStartDate = Math.min(...games.map(({ startsAt }) => +startsAt));
    return +firstStartDate * 1000 < Date.now();
};
const getExpressIsPendingResolution = (games) => {
    const lastStartDate = Math.max(...games.map(({ startsAt }) => +startsAt));
    const lastGames = games.filter(({ startsAt }) => +startsAt === lastStartDate);
    return lastGames.some(({ status, startsAt }) => {
        return getGameStatus({ graphStatus: status, startsAt: +startsAt, isGameInLive: false }) === GameStatus.PendingResolution;
    });
};
const getBetStatus = (props) => {
    const { games, graphStatus, isLiveBet } = props;
    if (graphStatus === BetStatus$1.Canceled) {
        return BetStatus.Canceled;
    }
    if (graphStatus === BetStatus$1.Resolved) {
        return BetStatus.Resolved;
    }
    const isExpress = games.length > 1;
    const isPendingResolution = isExpress
        ? getExpressIsPendingResolution(games)
        : getGameStatus({ graphStatus: games[0].status, startsAt: +games[0].startsAt, isGameInLive: isLiveBet }) === GameStatus.PendingResolution;
    if (isPendingResolution) {
        return BetStatus.PendingResolution;
    }
    const isLive = isExpress
        ? getExpressIsLive(games)
        : getGameStatus({ graphStatus: games[0].status, startsAt: +games[0].startsAt, isGameInLive: isLiveBet }) === GameStatus.Live;
    if (isLive) {
        return BetStatus.Live;
    }
    return BetStatus.Accepted;
};const getLiveBetFee = async (chainId) => {
    const api = getApiUrl(chainId);
    const environment = environments[chainId];
    const response = await fetch(`${api}/orders/gas?environment=${environment}`);
    const data = await response.json();
    return data;
};const usePrematchBets = (props) => {
    const { filter, orderBy = Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, } = props;
    const { prematchClient } = useApolloClients();
    const options = useMemo(() => {
        const variables = {
            first: filter.limit || 1000,
            skip: filter.offset,
            orderBy,
            orderDirection: orderDir,
            where: {
                actor: filter.bettor?.toLowerCase(),
            },
        };
        return {
            variables,
            ssr: false,
            client: prematchClient,
            skip: !filter.bettor,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter.limit,
        filter.offset,
        filter.bettor,
        orderBy,
        orderDir,
    ]);
    const { data, loading, error } = useQuery(BetsDocument, options);
    const bets = useMemo(() => {
        if (!data?.bets?.length) {
            return [];
        }
        return data.bets.map((rawBet) => {
            const { tokenId, status, amount, odds, settledOdds, createdAt, result, core: { address: coreAddress, liquidityPool: { address: lpAddress } }, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, freebet, txHash, selections, } = rawBet;
            const isWin = result === BetResult.Won;
            const isLose = result === BetResult.Lost;
            const isCanceled = status === BetStatus$1.Canceled;
            // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
            // so we should validate it by "win"/"canceled" statuses
            const isRedeemed = (isWin || isCanceled) && _isRedeemed;
            const isFreebet = Boolean(freebet);
            const freebetId = freebet?.freebetId;
            const freebetContractAddress = freebet?.contractAddress;
            const payout = isRedeemable && isWin ? +_payout : null;
            const betDiff = isFreebet ? amount : 0; // for freebet we must exclude bonus value from possible win
            const totalOdds = settledOdds ? +settledOdds : +odds;
            const possibleWin = +amount * totalOdds - +betDiff;
            const outcomes = selections
                .map((selection) => {
                const { odds, result, outcome: { outcomeId, condition: { conditionId, status: conditionStatus, game } } } = selection;
                const isWin = result ? result === SelectionResult.Won : null;
                const isLose = result ? result === SelectionResult.Lost : null;
                const isCanceled = (conditionStatus === ConditionStatus.Canceled
                    || game.status === GameStatus$1.Canceled);
                const marketName = getMarketName({ outcomeId });
                const selectionName = getSelectionName({ outcomeId, withPoint: true });
                return {
                    selectionName,
                    outcomeId,
                    conditionId,
                    coreAddress,
                    odds: +odds,
                    marketName,
                    game,
                    isWin,
                    isLose,
                    isCanceled,
                };
            })
                .sort((a, b) => +a.game.startsAt - +b.game.startsAt);
            const bet = {
                tokenId,
                freebetContractAddress: freebetContractAddress,
                freebetId,
                txHash,
                totalOdds,
                status,
                amount,
                possibleWin,
                payout,
                createdAt: +createdAt,
                isWin,
                isLose,
                isRedeemable,
                isRedeemed,
                isCanceled,
                coreAddress: coreAddress,
                lpAddress: lpAddress,
                outcomes,
                isLive: false,
            };
            return bet;
        });
    }, [data]);
    return {
        loading,
        bets,
        error,
    };
};const useLiveBets = (props) => {
    const { filter, orderBy = Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const [bets, setBets] = useState([]);
    const [isGamesFetching, setGamesFetching] = useState(true);
    const options = useMemo(() => {
        const variables = {
            first: filter.limit || 1000,
            skip: filter.offset,
            orderBy,
            orderDirection: orderDir,
            where: {
                actor: filter.bettor?.toLowerCase(),
            },
        };
        return {
            variables,
            ssr: false,
            client: prematchClient,
            skip: !filter.bettor,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter.limit,
        filter.offset,
        filter.bettor,
        orderBy,
        orderDir,
    ]);
    const { data, loading: isBetsFetching, error } = useQuery(LiveBetsDocument, options);
    const { liveBets } = data || { liveBets: [] };
    const formattedBets = useMemo(() => {
        if (!liveBets.length) {
            return [];
        }
        return liveBets.map((rawBet) => {
            const { tokenId, status, amount, odds, settledOdds, createdAt, result, core: { address: coreAddress, liquidityPool: { address: lpAddress } }, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, txHash, selections, } = rawBet;
            const isWin = result === BetResult.Won;
            const isLose = result === BetResult.Lost;
            const isCanceled = status === BetStatus$1.Canceled;
            // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
            // so we should validate it by "win"/"canceled" statuses
            const isRedeemed = (isWin || isCanceled) && _isRedeemed;
            const payout = isRedeemable && isWin ? +_payout : null;
            const totalOdds = settledOdds ? +settledOdds : +odds;
            const possibleWin = +amount * totalOdds;
            const outcomes = selections
                .map((selection) => {
                const { odds, result, outcome: { outcomeId, condition: { conditionId, status: conditionStatus, gameId } } } = selection;
                const isWin = result ? result === SelectionResult.Won : null;
                const isLose = result ? result === SelectionResult.Lost : null;
                const isCanceled = conditionStatus === ConditionStatus.Canceled;
                const marketName = getMarketName({ outcomeId });
                const selectionName = getSelectionName({ outcomeId, withPoint: true });
                return {
                    selectionName,
                    outcomeId,
                    conditionId,
                    coreAddress,
                    odds: +odds,
                    marketName,
                    gameId,
                    isWin,
                    isLose,
                    isCanceled,
                };
            });
            const bet = {
                tokenId,
                txHash,
                totalOdds,
                status,
                amount,
                possibleWin,
                payout,
                createdAt: +createdAt,
                isWin,
                isLose,
                isRedeemable,
                isRedeemed,
                isCanceled,
                coreAddress: coreAddress,
                lpAddress: lpAddress,
                outcomes,
                isLive: true,
            };
            return bet;
        });
    }, [liveBets]);
    useEffect(() => {
        if (!formattedBets.length) {
            setGamesFetching(false);
            return;
        }
        (async () => {
            let games = {};
            const needToGetGames = new Set();
            formattedBets.forEach(({ outcomes }) => {
                const gameId = outcomes[0]?.gameId;
                const game = liveClient.cache.readFragment({
                    id: liveClient.cache.identify({ __typename: 'Game', id: gameId }),
                    fragment: MainGameInfoFragmentDoc,
                    fragmentName: 'MainGameInfo',
                });
                if (game) {
                    games[gameId] = game;
                }
                else {
                    needToGetGames.add(gameId);
                }
            });
            if (needToGetGames.size) {
                const { data: { games: _games } } = await liveClient.query({
                    query: GamesDocument,
                    variables: {
                        where: {
                            gameId_in: [...needToGetGames],
                        },
                    },
                    fetchPolicy: 'network-only',
                });
                const fetchedGames = _games.reduce((acc, game) => {
                    acc[game.gameId] = game;
                    return acc;
                }, {});
                games = {
                    ...games,
                    ...fetchedGames,
                };
            }
            const betsWithGames = formattedBets.map(bet => {
                const gameId = bet.outcomes[0]?.gameId;
                const game = games[gameId];
                if (game) {
                    return {
                        ...bet,
                        outcomes: [{
                                ...bet.outcomes[0],
                                game,
                            }],
                    };
                }
            }).filter(Boolean);
            setGamesFetching(false);
            setBets(betsWithGames);
        })();
        return () => {
            setBets([]);
        };
    }, [formattedBets]);
    return {
        loading: isBetsFetching || isGamesFetching,
        bets,
        error,
    };
};const useBetTokenBalance = () => {
    const { appChain, betToken } = useChain();
    const { address } = useAccount();
    const { isLoading, data, error } = useBalance({
        chainId: appChain.id,
        address,
        token: betToken.address,
    });
    return {
        loading: isLoading,
        rawBalance: data?.value,
        balance: data?.formatted,
        error,
    };
};const ConditionFragmentDoc = gql `
    fragment Condition on Condition {
  id
  conditionId
  status
  outcomes {
    outcomeId
  }
  game {
    gameId
    sport {
      sportId
    }
  }
}
    `;const ConditionsDocument = gql `
    query Conditions($where: Condition_filter!) {
  conditions(where: $where, first: 1000, subgraphError: allow) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;const useConditions = (props) => {
    const { gameId, isLive, livePollInterval, filter } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const { appChain } = useChain();
    const variables = useMemo(() => {
        const vars = {
            where: {
                game_: {
                    gameId,
                },
            },
        };
        if (filter?.outcomeIds) {
            vars.where.outcomesIds_contains = filter.outcomeIds;
        }
        return vars;
    }, [gameId, filter?.outcomeIds?.join(',')]);
    const { data: prematchData, loading: isPrematchLoading, error: prematchError, } = useQuery(ConditionsDocument$1, {
        variables: variables,
        ssr: false,
        client: prematchClient,
        skip: isLive,
        notifyOnNetworkStatusChange: true,
    });
    const { data: liveData, loading: isLiveLoading, error: liveError, } = useQuery(ConditionsDocument, {
        variables: variables,
        ssr: false,
        client: liveClient,
        skip: !isLive || !liveSupportedChains.includes(appChain.id),
        pollInterval: livePollInterval,
    });
    const data = (isLive ? liveData : prematchData) || {};
    return {
        conditions: data?.conditions,
        loading: isPrematchLoading || isLiveLoading,
        error: prematchError || liveError,
    };
};const useGame = (props) => {
    const { gameId } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const variables = useMemo(() => ({
        gameId: gameId,
    }), [gameId]);
    const { data: prematchData, loading: isPrematchLoading, error: prematchError } = useQuery(GameDocument, {
        variables,
        ssr: false,
        client: prematchClient,
        skip: !gameId,
    });
    const { data: liveData, loading: isLiveLoading, error: liveError } = useQuery(GameDocument, {
        variables,
        ssr: false,
        client: liveClient,
        skip: !gameId,
    });
    const prematchGame = prematchData?.games?.[0];
    const liveGame = liveData?.games?.[0];
    const game = liveGame || prematchGame;
    const isGameInLive = Boolean(liveGame);
    return {
        game,
        loading: isPrematchLoading || isLiveLoading,
        error: prematchError || liveError,
        isGameInLive,
    };
};const groupDataByConditionId = (data) => {
    return data.reduce((acc, item) => {
        const { conditionId } = item;
        const key = String(conditionId);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
};
const groupMarkets = (conditions, gameId, lpAddress) => {
    const outcomesByMarkets = {};
    const result = {};
    const sportId = conditions[0].game.sport.sportId;
    conditions.forEach((condition) => {
        const { conditionId, outcomes: rawOutcomes, status } = condition;
        const coreAddress = condition.core?.address || liveHostAddress;
        const isExpressForbidden = condition.isExpressForbidden ?? true;
        rawOutcomes.forEach((rawOutcome) => {
            const { outcomeId } = rawOutcome;
            const odds = rawOutcome.odds;
            const betTypeOdd = dictionaries.outcomes[outcomeId];
            if (!betTypeOdd) {
                console.warn(`betTypeOdd not found for "outcomeId: ${outcomeId}"`);
                return;
            }
            const marketKey = getMarketKey(outcomeId);
            const marketName = getMarketName({ outcomeId });
            const marketDescription = getMarketDescription({ outcomeId });
            const selectionName = getSelectionName({ outcomeId, withPoint: true });
            const outcome = {
                coreAddress: coreAddress,
                lpAddress: lpAddress,
                conditionId,
                outcomeId,
                selectionName,
                status,
                gameId,
                isExpressForbidden,
            };
            if (odds) {
                outcome.odds = +odds;
            }
            if (!outcomesByMarkets[marketKey]) {
                outcomesByMarkets[marketKey] = [];
                result[marketKey] = {
                    name: marketName,
                    marketKey,
                    description: marketDescription,
                    outcomeRows: [],
                };
            }
            outcomesByMarkets[marketKey].push(outcome);
        });
    });
    // markets with different conditionIds
    const marketsWithDifferentConditionIds = ['1', '2'];
    // sort by outcomeId and group by conditionId
    Object.keys(outcomesByMarkets).forEach((marketKey) => {
        const marketId = marketKey.split('-')[0];
        // get the conditions related to the market
        const outcomes = outcomesByMarkets[marketKey];
        const validSelectionsByMarketId = {
            '1': [1, 2, 3],
            '2': [4, 5, 6],
        };
        const validSelections = validSelectionsByMarketId[marketId];
        if (validSelections?.length) {
            const outcomesSelections = outcomes.map((outcome) => (dictionaries.outcomes[String(outcome.outcomeId)].selectionId));
            const isValid = validSelections.every(selection => outcomesSelections.includes(selection));
            if (!isValid) {
                return;
            }
        }
        // sort the conditions by selectionId
        outcomes.sort((a, b) => {
            const { outcomes: dictionaryOutcomes } = dictionaries;
            const left = dictionaryOutcomes[String(a.outcomeId)].selectionId;
            const right = dictionaryOutcomes[String(b.outcomeId)].selectionId;
            return left - right;
        });
        // these markets have few outcomes and not requires additional actions
        if (marketsWithDifferentConditionIds.includes(marketId)) {
            result[marketKey].outcomeRows = [outcomes];
        }
        // others need to be grouped by conditionId to allow draw outcomes in rows in UI, e.g.
        //
        // Team 1 - Total Goals:
        // Over (0.5)   Under (0.5)
        // Over (1.5)   Under (1.5)
        //
        else {
            const conditionsByConditionId = groupDataByConditionId(outcomes);
            result[marketKey].outcomeRows = Object.values(conditionsByConditionId).sort((a, b) => {
                const { points, outcomes: dictionaryOutcomes } = dictionaries;
                /*
                  we should always sort by param in first outcome
        
                  Handicap
                  Team 1 (-2.5)   Team 2 (2.5)
                  Team 1 (-1.5)   Team 2 (1.5)
        
                  Total Goals
                  Over (1.5)   Under (1.5)
                  Over (2.5)   Under (2.5)
                */
                const aPointId = dictionaryOutcomes[String(a[0].outcomeId)].pointsId;
                const bPointId = dictionaryOutcomes[String(b[0].outcomeId)].pointsId;
                const aFirstOutcome = +points[aPointId];
                const bFirstOutcome = +points[bPointId];
                return aFirstOutcome - bFirstOutcome;
            });
        }
    });
    let markets = Object.values(result);
    const orderedMarketKeys = dictionaries.marketOrders?.[sportId];
    if (!orderedMarketKeys) {
        return markets;
    }
    return markets.sort((a, b) => {
        const prevMarketIndex = orderedMarketKeys.indexOf(a.marketKey);
        const nextMarketIndex = orderedMarketKeys.indexOf(b.marketKey);
        if (prevMarketIndex >= 0 && nextMarketIndex >= 0) {
            return prevMarketIndex - nextMarketIndex;
        }
        if (prevMarketIndex < 0 && nextMarketIndex >= 0) {
            return 1;
        }
        if (prevMarketIndex >= 0 && nextMarketIndex < 0) {
            return -1;
        }
        return 0;
    });
};
const useGameMarkets = (props) => {
    const { gameId, gameStatus, filter, livePollInterval } = props;
    const { contracts } = useChain();
    const { loading, conditions, error } = useConditions({
        gameId,
        filter,
        isLive: gameStatus === GameStatus.Live,
        livePollInterval,
    });
    // generate unique key for memo deps
    const conditionIds = conditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const markets = useMemo(() => {
        if (!conditions?.length) {
            return [];
        }
        return groupMarkets(conditions, gameId, contracts.lp.address);
    }, [conditionIds]);
    return {
        loading,
        markets,
        error,
    };
};const useGames = (props) => {
    const { filter, orderBy = Game_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Desc, isLive, } = props || {};
    const { prematchClient, liveClient } = useApolloClients();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: 1000,
            orderBy,
            orderDirection: orderDir,
            where: {
                hasActiveConditions: true,
                status_in: [GameStatus$1.Created, GameStatus$1.Paused],
            },
        };
        if (isLive) {
            variables.where.startsAt_lt = startsAt;
        }
        else {
            variables.where.startsAt_gt = startsAt;
        }
        if (filter?.limit) {
            variables.first = filter.limit;
        }
        if (filter?.offset) {
            variables.skip = filter.offset;
        }
        if (filter?.sportHub) {
            variables.where.sport_ = {
                sporthub: filter.sportHub,
            };
        }
        if (filter?.sportSlug) {
            variables.where.sport_ = {
                slug_starts_with_nocase: filter.sportSlug,
            };
        }
        if (filter?.leagueSlug) {
            variables.where.league_ = {
                slug_ends_with_nocase: filter.leagueSlug,
            };
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter?.limit,
        filter?.offset,
        filter?.sportSlug,
        filter?.sportHub,
        filter?.leagueSlug,
        orderBy,
        orderDir,
        startsAt,
        isLive,
    ]);
    const { data, loading, error } = useQuery(GamesDocument, options);
    return {
        games: data?.games,
        loading,
        error,
    };
};const useSports = (props) => {
    const { filter, gameOrderBy = Game_OrderBy.StartsAt, orderDir = OrderDirection.Asc, isLive, } = props || {};
    const { prematchClient, liveClient } = useApolloClients();
    const { contracts } = useChain();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: filter?.limit || 1000,
            sportFilter: {},
            countryFilter: {},
            leagueFilter: {},
            gameFilter: {
                hasActiveConditions: true,
                status_in: [GameStatus$1.Created, GameStatus$1.Paused],
            },
            gameOrderBy,
            gameOrderDirection: orderDir,
        };
        if (filter?.sportSlug) {
            variables.sportFilter.slug = filter.sportSlug;
        }
        if (filter?.sportHub) {
            variables.sportFilter.sporthub = filter.sportHub;
        }
        if (filter?.countrySlug) {
            variables.countryFilter.slug = filter.countrySlug;
        }
        if (isLive) {
            variables.gameFilter.startsAt_lt = startsAt;
        }
        else {
            variables.gameFilter.startsAt_gt = startsAt;
            variables.gameFilter.liquidityPool = contracts.lp.address.toLowerCase();
        }
        variables.leagueFilter.games_ = variables.gameFilter;
        if (filter?.leagueSlug) {
            variables.leagueFilter.slug = filter.leagueSlug;
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        isLive,
        contracts.lp.address,
        gameOrderBy,
        orderDir,
        filter?.limit,
        filter?.sportHub,
        filter?.sportSlug,
        filter?.countrySlug,
        filter?.leagueSlug,
        startsAt,
    ]);
    const { data, loading, error } = useQuery(SportsDocument, options);
    const { sports } = data || { sports: [] };
    const formattedSports = useMemo(() => {
        if (!sports.length) {
            return [];
        }
        const filteredSports = sports.map(sport => {
            const { countries } = sport;
            const filteredCountries = countries.filter(({ leagues }) => leagues.length);
            return {
                ...sport,
                countries: filteredCountries,
            };
        }).filter(sport => sport.countries.length);
        if (gameOrderBy === Game_OrderBy.Turnover) {
            const sportsWithTurnover = filteredSports.map(sport => {
                const { countries } = sport;
                const turnover = countries.reduce((acc, { turnover }) => {
                    acc += +turnover;
                    return acc;
                }, 0);
                return {
                    ...sport,
                    turnover,
                };
            });
            return sportsWithTurnover.sort((a, b) => b.turnover - a.turnover);
        }
        if (gameOrderBy === Game_OrderBy.StartsAt) {
            return filteredSports.map(sport => {
                const { countries } = sport;
                const sortedCountries = countries.map(country => {
                    const { leagues } = country;
                    return {
                        ...country,
                        leagues: [...leagues].sort((a, b) => +a.games[0].startsAt - +b.games[0].startsAt),
                    };
                }).sort((a, b) => +a.leagues[0].games[0].startsAt - +b.leagues[0].games[0].startsAt);
                return {
                    ...sport,
                    countries: sortedCountries,
                };
            }).sort((a, b) => +a.countries[0].leagues[0].games[0].startsAt - +b.countries[0].leagues[0].games[0].startsAt);
        }
        return filteredSports;
    }, [sports]);
    return {
        loading,
        sports: formattedSports,
        error,
    };
};const useGameStatus = ({ graphStatus, startsAt, isGameExistInLive }) => {
    const startDate = +startsAt * 1000;
    const [isGameStarted, setGameStarted] = useState(Date.now() > startDate);
    const gameStatus = useMemo(() => {
        return getGameStatus({
            graphStatus,
            startsAt,
            isGameInLive: isGameExistInLive,
        });
    }, [graphStatus, isGameStarted, isGameExistInLive]);
    useEffect(() => {
        if (isGameStarted) {
            return;
        }
        const timer = setTimeout(() => {
            setGameStarted(true);
        }, startDate - Date.now());
        return () => {
            clearTimeout(timer);
        };
    }, [startDate]);
    return {
        status: gameStatus,
        isGameStarted,
    };
};const useNativeBalance = () => {
    const { appChain } = useChain();
    const { address } = useAccount();
    const { isLoading, data, error } = useBalance({
        chainId: appChain.id,
        address,
    });
    return {
        loading: isLoading,
        rawBalance: data?.value,
        balance: data?.formatted,
        error,
    };
};const useSportsNavigation = (props = {}) => {
    const { withGameCount = false, isLive } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: 1000,
            withGameCount,
            where: {
                hasActiveConditions: true,
                status_in: [GameStatus$1.Created, GameStatus$1.Paused],
            },
        };
        if (isLive) {
            variables.where.startsAt_lt = startsAt;
        }
        else {
            variables.where.startsAt_gt = startsAt;
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [withGameCount, startsAt, isLive]);
    const { data, loading, error } = useQuery(NavigationDocument, options);
    return {
        sports: data?.sports,
        loading,
        error,
    };
};const BettorFragmentDoc = gql `
    fragment Bettor on Bettor {
  id
  rawToPayout
  rawInBets
  rawTotalPayout
  rawTotalProfit
  betsCount
  wonBetsCount
  lostBetsCount
}
    `;const ConditionDocument$1 = gql `
    query Condition($conditionId: BigInt!) {
  condition(id: $conditionId, subgraphError: allow) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;const ConditionDocument = gql `
    query Condition($id: String!) {
  condition(id: $id, subgraphError: allow) {
    ...Condition
  }
}
    ${ConditionFragmentDoc$1}`;const useBetsCache = () => {
    const { prematchClient, liveClient } = useApolloClients();
    const { contracts, betToken } = useChain();
    const { address } = useAccount();
    const updateBetCache = ({ coreAddress, tokenId }, values) => {
        const isLive = contracts.liveCore ? coreAddress.toLowerCase() === contracts.liveCore.address.toLowerCase() : false;
        const { cache } = prematchClient;
        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
        let bet;
        if (isLive) {
            bet = cache.updateFragment({
                id: cache.identify({ __typename: 'LiveBet', id: betEntityId }),
                fragment: LiveBetFragmentDoc,
                fragmentName: 'LiveBet',
            }, (data) => ({
                ...data,
                ...values,
            }));
        }
        else {
            bet = cache.updateFragment({
                id: cache.identify({ __typename: 'Bet', id: betEntityId }),
                fragment: BetFragmentDoc,
                fragmentName: 'Bet',
            }, (data) => ({
                ...data,
                ...values,
            }));
        }
        if (!bet) {
            return;
        }
        const bettorEntity = `${contracts.lp.address.toLowerCase()}_${address.toLowerCase()}_${bet.affiliate.toLowerCase()}`;
        prematchClient.cache.updateFragment({
            id: prematchClient.cache.identify({ __typename: 'Bettor', id: bettorEntity }),
            fragment: BettorFragmentDoc,
            fragmentName: 'Bettor',
        }, (data) => {
            if (!data) {
                return data;
            }
            const rawPayout = parseUnits(bet.payout, betToken.decimals);
            const newRawToPayout = BigInt(data.rawToPayout) - rawPayout;
            return {
                ...data,
                rawToPayout: String(newRawToPayout),
            };
        });
    };
    const addBet = async (props) => {
        const { bet, odds, affiliate, receipt } = props;
        const { rawAmount, selections } = bet;
        const coreAddress = selections[0].coreAddress;
        const isLive = coreAddress.toLowerCase() === liveHostAddress.toLowerCase();
        const client = isLive ? liveClient : prematchClient;
        const { cache } = client;
        const selectionFragments = [];
        for (let index = 0; index < selections.length; index++) {
            const { outcomeId, conditionId: _conditionId } = selections[index];
            const conditionId = String(_conditionId);
            if (isLive) {
                let condition = cache.readFragment({
                    id: cache.identify({ __typename: 'Condition', id: conditionId }),
                    fragment: ConditionFragmentDoc,
                    fragmentName: 'Condition',
                });
                if (!condition) {
                    const { data: { condition: _condition } } = await client.query({
                        query: ConditionDocument$1,
                        variables: {
                            conditionId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    condition = _condition;
                }
                const gameId = condition.game.gameId;
                const selectionFragment = {
                    __typename: 'LiveSelection',
                    odds: String(odds[`${conditionId}-${outcomeId}`]),
                    result: null,
                    outcome: {
                        __typename: 'LiveOutcome',
                        outcomeId: String(outcomeId),
                        condition: {
                            __typename: 'LiveCondition',
                            conditionId,
                            status: ConditionStatus.Created,
                            gameId,
                        },
                    },
                };
                selectionFragments.push(selectionFragment);
            }
            else {
                const conditionEntityId = `${coreAddress.toLowerCase()}_${conditionId}`;
                let condition = cache.readFragment({
                    id: cache.identify({ __typename: 'Condition', id: conditionEntityId }),
                    fragment: ConditionFragmentDoc$1,
                    fragmentName: 'Condition',
                });
                if (!condition) {
                    const { data: { condition: _condition } } = await client.query({
                        query: ConditionDocument,
                        variables: {
                            id: conditionEntityId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    condition = _condition;
                }
                const gameId = condition?.game.gameId;
                const gameEntityId = `${contracts.lp.address.toLowerCase()}_${gameId}`;
                let game = cache.readFragment({
                    id: cache.identify({ __typename: 'Game', id: gameEntityId }),
                    fragment: MainGameInfoFragmentDoc,
                    fragmentName: 'MainGameInfo',
                });
                if (!game) {
                    const { data: { games } } = await client.query({
                        query: GameDocument,
                        variables: {
                            gameId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    game = games[0];
                }
                const selectionFragment = {
                    __typename: 'Selection',
                    odds: String(odds[`${conditionId}-${outcomeId}`]),
                    result: null,
                    outcome: {
                        __typename: 'Outcome',
                        outcomeId: String(outcomeId),
                        condition: {
                            __typename: 'Condition',
                            conditionId,
                            status: ConditionStatus.Created,
                            game,
                        },
                    },
                };
                selectionFragments.push(selectionFragment);
            }
        }
        let tokenId;
        let rawOdds;
        if (isLive) {
            const receiptArgs = getEventArgsFromTxReceipt({ receipt, eventName: 'NewLiveBet', abi: liveCoreAbi });
            tokenId = (receiptArgs?.tokenId).toString();
            rawOdds = receiptArgs?.odds;
        }
        else {
            const isExpress = selections.length > 1;
            const abi = isExpress ? contracts.prematchComboCore.abi : contracts.prematchCore.abi;
            let eventParams;
            if (!isExpress) {
                const { conditionId, outcomeId } = selections[0];
                eventParams = {
                    conditionId: BigInt(conditionId),
                    outcomeId: BigInt(outcomeId),
                };
            }
            const receiptArgs = getEventArgsFromTxReceipt({
                receipt,
                eventName: 'NewBet',
                abi,
                params: eventParams,
            });
            tokenId = (isExpress ? receiptArgs?.betId : receiptArgs?.tokenId)?.toString();
            rawOdds = isExpress ? receiptArgs?.bet.odds : receiptArgs?.odds;
        }
        const rawPotentialPayout = rawAmount * rawOdds;
        const potentialPayout = formatUnits(rawPotentialPayout, betToken.decimals);
        const finalOdds = formatUnits(rawOdds, ODDS_DECIMALS);
        const amount = formatUnits(rawAmount, betToken.decimals);
        if (isLive) {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    liveBets: (bets) => {
                        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
                        const data = {
                            __typename: 'LiveBet',
                            id: betEntityId,
                            tokenId: tokenId,
                            core: {
                                address: coreAddress,
                                liquidityPool: {
                                    address: contracts.lp.address,
                                },
                            },
                            status: BetStatus$1.Accepted,
                            amount,
                            odds: finalOdds,
                            settledOdds: null,
                            createdAt: String(Math.floor(Date.now() / 1000)),
                            payout: null,
                            potentialPayout: potentialPayout,
                            isRedeemed: false,
                            isRedeemable: false,
                            result: null,
                            txHash: receipt.transactionHash,
                            affiliate,
                            selections: selectionFragments,
                        };
                        const newBet = prematchClient.cache.writeFragment({
                            fragment: LiveBetFragmentDoc,
                            fragmentName: 'LiveBet',
                            data,
                        });
                        return [newBet, ...bets];
                    },
                },
            });
        }
        else {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    bets: (bets) => {
                        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
                        const data = {
                            __typename: 'Bet',
                            id: betEntityId,
                            tokenId: tokenId,
                            core: {
                                address: coreAddress,
                                liquidityPool: {
                                    address: contracts.lp.address,
                                },
                            },
                            status: BetStatus$1.Accepted,
                            amount,
                            odds: finalOdds,
                            settledOdds: null,
                            createdAt: String(Math.floor(Date.now() / 1000)),
                            payout: null,
                            potentialPayout: potentialPayout,
                            isRedeemed: false,
                            isRedeemable: false,
                            freebet: bet.freebetContractAddress ? {
                                freebetId: String(bet.freebetId),
                                contractAddress: bet.freebetContractAddress,
                            } : null,
                            result: null,
                            txHash: receipt.transactionHash,
                            affiliate,
                            selections: selectionFragments,
                        };
                        const newBet = prematchClient.cache.writeFragment({
                            fragment: BetFragmentDoc,
                            fragmentName: 'Bet',
                            data,
                        });
                        return [newBet, ...bets];
                    },
                },
            });
        }
        const bettorEntity = `${contracts.lp.address.toLowerCase()}_${address.toLowerCase()}_${affiliate.toLowerCase()}`;
        const bettorFragment = cache.readFragment({
            id: cache.identify({ __typename: 'Bettor', id: bettorEntity }),
            fragment: BettorFragmentDoc,
            fragmentName: 'Bettor',
        });
        if (bettorFragment) {
            prematchClient.cache.updateFragment({
                id: prematchClient.cache.identify({ __typename: 'Bettor', id: bettorEntity }),
                fragment: BettorFragmentDoc,
                fragmentName: 'Bettor',
            }, (data) => ({
                ...data,
                betsCount: data.betsCount + 1,
                rawInBets: String(BigInt(data.rawInBets) + rawAmount),
            }));
        }
        else {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    bettors: (bettors) => {
                        const newBettor = prematchClient.cache.writeFragment({
                            fragment: BettorFragmentDoc,
                            fragmentName: 'Bettor',
                            data: {
                                __typename: 'Bettor',
                                id: bettorEntity,
                                rawToPayout: '0',
                                rawInBets: String(rawAmount),
                                rawTotalPayout: '0',
                                rawTotalProfit: '0',
                                betsCount: 1,
                                wonBetsCount: 0,
                                lostBetsCount: 0,
                            },
                        });
                        return [...bettors, newBettor];
                    },
                },
            });
        }
    };
    return {
        updateBetCache,
        addBet,
    };
};const useLiveBetFee = ({ enabled } = { enabled: true }) => {
    const { appChain } = useChain();
    const queryFn = async () => {
        const { gasAmount, relayerFeeAmount, beautyRelayerFeeAmount, } = await getLiveBetFee(appChain.id);
        return {
            gasAmount: BigInt(gasAmount),
            relayerFeeAmount: BigInt(relayerFeeAmount),
            formattedRelayerFeeAmount: beautyRelayerFeeAmount,
        };
    };
    let { isFetching, data, refetch } = useQuery$1({
        queryKey: ['/live-bet-fee', appChain.id],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
        refetchInterval: 10000,
    });
    if (!enabled) {
        data = undefined;
    }
    return {
        gasAmount: data?.gasAmount,
        relayerFeeAmount: data?.relayerFeeAmount,
        formattedRelayerFeeAmount: data?.formattedRelayerFeeAmount,
        refetch,
        loading: isFetching,
    };
};var LiveOrderState;
(function (LiveOrderState) {
    LiveOrderState["Created"] = "Created";
    LiveOrderState["Pending"] = "Pending";
    LiveOrderState["Sent"] = "Sent";
    LiveOrderState["Accepted"] = "Accepted";
    LiveOrderState["Rejected"] = "Rejected";
})(LiveOrderState || (LiveOrderState = {}));
const usePrepareBet = (props) => {
    const { betAmount: _betAmount, slippage, deadline, affiliate, selections, odds, totalOdds, liveEIP712Attention, onSuccess, onError, } = props;
    const isLiveBet = useMemo(() => {
        return selections.some(({ coreAddress }) => coreAddress === liveHostAddress);
    }, [selections]);
    const isBatch = !isLiveBet && typeof _betAmount === 'object';
    const account = useAccount();
    const publicClient = usePublicClient();
    const walletClient = useWalletClient();
    const { appChain, contracts, betToken, api, environment } = useChain();
    const { relayerFeeAmount: rawRelayerFeeAmount, formattedRelayerFeeAmount: relayerFeeAmount, loading: isRelayerFeeFetching, } = useLiveBetFee({
        enabled: isLiveBet,
    });
    const { addBet } = useBetsCache();
    const [isLiveBetPending, setLiveBetPending] = useState(false);
    const [isLiveBetProcessing, setLiveBetProcessing] = useState(false);
    const approveAddress = isLiveBet ? contracts.liveRelayer?.address : contracts.proxyFront.address;
    const allowanceTx = useReadContract({
        chainId: appChain.id,
        address: betToken.address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [
            account.address,
            approveAddress,
        ],
        query: {
            enabled: Boolean(account.address) && Boolean(approveAddress),
        },
    });
    const approveTx = useWriteContract();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
    });
    const betAmount = useMemo(() => {
        if (typeof _betAmount === 'string') {
            return +_betAmount;
        }
        return Object.values(_betAmount).reduce((acc, amount) => acc + +amount, 0);
    }, [_betAmount]);
    const isApproveRequired = useMemo(() => {
        if (!betAmount
            || typeof allowanceTx?.data === 'undefined'
            || (isLiveBet && typeof relayerFeeAmount === 'undefined')) {
            return false;
        }
        let approveAmount = betAmount;
        if (isLiveBet) {
            approveAmount += +relayerFeeAmount;
        }
        return allowanceTx.data < parseUnits(String(approveAmount), betToken.decimals);
    }, [allowanceTx.data, isLiveBet, relayerFeeAmount, betAmount]);
    const approve = async () => {
        const hash = await approveTx.writeContractAsync({
            address: betToken.address,
            abi: erc20Abi,
            functionName: 'approve',
            args: [
                approveAddress,
                maxUint256,
            ],
        });
        await publicClient.waitForTransactionReceipt({
            hash,
        });
        allowanceTx.refetch();
    };
    const betTx = useWriteContract();
    const betReceipt = useWaitForTransactionReceipt({
        hash: betTx.data,
    });
    const placeBet = async () => {
        if (!totalOdds) {
            return;
        }
        let bets = [];
        const fixedAmount = parseFloat(String(betAmount)).toFixed(betToken.decimals);
        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
        const rawDeadline = BigInt(Math.floor(Date.now() / 1000) + (deadline || DEFAULT_DEADLINE));
        let txHash;
        try {
            if (isLiveBet) {
                setLiveBetPending(true);
                const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
                const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                const { conditionId, outcomeId } = selections[0];
                bets.push({
                    rawAmount,
                    selections,
                });
                const order = {
                    bet: {
                        attention: liveEIP712Attention || 'By signing this transaction, I agree to place a bet for a live event on \'Azuro SDK Example',
                        affiliate,
                        core: contracts.liveCore.address,
                        amount: String(rawAmount),
                        chainId: appChain.id,
                        conditionId: conditionId,
                        outcomeId: +outcomeId,
                        minOdds: String(rawMinOdds),
                        nonce: String(Date.now()),
                        expiresAt: Math.floor(Date.now() / 1000) + 2000,
                        relayerFeeAmount: String(rawRelayerFeeAmount),
                    },
                };
                const EIP712Domain = {
                    name: 'Live Betting',
                    version: '1.0.0',
                    chainId: appChain.id,
                    verifyingContract: contracts.liveCore.address,
                };
                const clientBetDataTypes = {
                    ClientBetData: [
                        { name: 'attention', type: 'string' },
                        { name: 'affiliate', type: 'address' },
                        { name: 'core', type: 'address' },
                        { name: 'amount', type: 'uint128' },
                        { name: 'nonce', type: 'uint256' },
                        { name: 'conditionId', type: 'uint256' },
                        { name: 'outcomeId', type: 'uint64' },
                        { name: 'minOdds', type: 'uint64' },
                        { name: 'expiresAt', type: 'uint256' },
                        { name: 'chainId', type: 'uint256' },
                        { name: 'relayerFeeAmount', type: 'uint256' },
                    ],
                };
                const signature = await walletClient.data.signTypedData({
                    account: account.address,
                    domain: EIP712Domain,
                    primaryType: 'ClientBetData',
                    types: clientBetDataTypes,
                    message: {
                        attention: order.bet.attention,
                        affiliate: order.bet.affiliate,
                        core: order.bet.core,
                        amount: BigInt(order.bet.amount),
                        nonce: BigInt(order.bet.nonce),
                        conditionId: BigInt(order.bet.conditionId),
                        outcomeId: BigInt(order.bet.outcomeId),
                        minOdds: BigInt(order.bet.minOdds),
                        expiresAt: BigInt(order.bet.expiresAt),
                        chainId: BigInt(order.bet.chainId),
                        relayerFeeAmount: BigInt(order.bet.relayerFeeAmount),
                    },
                });
                setLiveBetPending(false);
                setLiveBetProcessing(true);
                const signedBet = {
                    environment,
                    bettor: account.address.toLowerCase(),
                    data: order,
                    bettorSignature: signature,
                };
                const createOrderResponse = await fetch(`${api}/orders`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(signedBet),
                });
                const { id: orderId, state: newOrderState, errorMessage, } = await createOrderResponse.json();
                if (newOrderState === LiveOrderState.Created) {
                    txHash = await new Promise((res, rej) => {
                        const interval = setInterval(async () => {
                            const getOrderResponse = await fetch(`${api}/orders/${orderId}`);
                            const { state, txHash } = await getOrderResponse.json();
                            if (state === LiveOrderState.Rejected) {
                                clearInterval(interval);
                                rej();
                            }
                            if (txHash) {
                                clearInterval(interval);
                                res(txHash);
                            }
                        }, 1000);
                    });
                    setLiveBetProcessing(false);
                }
                else {
                    throw Error(errorMessage);
                }
            }
            else {
                let betData;
                if (selections.length > 1 && isBatch) {
                    betData = selections.map(selection => {
                        const { conditionId, outcomeId } = selection;
                        const fixedAmount = parseFloat(_betAmount[`${conditionId}-${outcomeId}`]).toFixed(betToken.decimals);
                        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
                        const fixedMinOdds = calcMindOdds({ odds: odds[`${conditionId}-${outcomeId}`], slippage });
                        const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                        const data = getPrematchBetDataBytes([selection]);
                        bets.push({
                            rawAmount,
                            selections: [selection],
                        });
                        return {
                            core: contracts.prematchCore.address,
                            amount: rawAmount,
                            expiresAt: rawDeadline,
                            extraData: {
                                affiliate,
                                minOdds: rawMinOdds,
                                data,
                            },
                        };
                    });
                }
                else {
                    const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
                    const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                    const coreAddress = selections.length > 1 ? contracts.prematchComboCore.address : contracts.prematchCore.address;
                    const data = getPrematchBetDataBytes(selections);
                    bets.push({
                        rawAmount,
                        selections,
                    });
                    betData = [
                        {
                            core: coreAddress,
                            amount: rawAmount,
                            expiresAt: rawDeadline,
                            extraData: {
                                affiliate,
                                minOdds: rawMinOdds,
                                data,
                            },
                        },
                    ];
                }
                txHash = await betTx.writeContractAsync({
                    address: contracts.proxyFront.address,
                    abi: contracts.proxyFront.abi,
                    functionName: 'bet',
                    args: [
                        contracts.lp.address,
                        betData,
                    ],
                });
            }
            const receipt = await publicClient?.waitForTransactionReceipt({
                hash: txHash,
            });
            if (receipt) {
                bets.forEach((bet) => {
                    addBet({
                        receipt,
                        affiliate,
                        odds,
                        bet,
                    });
                });
            }
            if (onSuccess) {
                onSuccess(receipt);
            }
        }
        catch (err) {
            setLiveBetPending(false);
            setLiveBetProcessing(false);
            if (onError) {
                onError(err);
            }
        }
    };
    const submit = () => {
        if (isApproveRequired) {
            return approve();
        }
        return placeBet();
    };
    return {
        submit,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        betTx: {
            isPending: betTx.isPending || isLiveBetPending,
            isProcessing: betReceipt.isLoading || isLiveBetProcessing,
        },
        relayerFeeAmount,
        isAllowanceLoading: allowanceTx.isLoading,
        isApproveRequired,
        isRelayerFeeLoading: isRelayerFeeFetching,
    };
};const useRedeemBet = () => {
    const publicClient = usePublicClient();
    const { contracts } = useChain();
    const { updateBetCache } = useBetsCache();
    const redeemTx = useWriteContract();
    const batchRedeemTx = useWriteContract();
    const receipt = useWaitForTransactionReceipt({
        hash: redeemTx.data,
    });
    const batchReceipt = useWaitForTransactionReceipt({
        hash: batchRedeemTx.data,
    });
    const submit = async (props) => {
        const { bets } = props;
        const isBatch = bets.length > 1;
        let hash;
        if (isBatch) {
            const betsData = bets.map(({ tokenId, coreAddress }) => ({
                core: coreAddress,
                tokenId: BigInt(tokenId),
                isNative: false,
            }));
            hash = await batchRedeemTx.writeContractAsync({
                address: contracts.proxyFront.address,
                abi: contracts.proxyFront.abi,
                functionName: 'withdrawPayouts',
                args: [betsData],
            });
        }
        else {
            const { tokenId, coreAddress } = bets[0];
            hash = await redeemTx.writeContractAsync({
                address: contracts.lp.address,
                abi: contracts.lp.abi,
                functionName: 'withdrawPayout',
                args: [
                    coreAddress,
                    BigInt(tokenId),
                ],
            });
        }
        const receipt = await publicClient.waitForTransactionReceipt({
            hash,
        });
        bets.forEach(({ tokenId, coreAddress }) => {
            updateBetCache({
                coreAddress,
                tokenId,
            }, {
                isRedeemed: true,
                isRedeemable: false,
            });
        });
        return receipt;
    };
    return {
        isPending: redeemTx.isPending || batchRedeemTx.isPending,
        isProcessing: receipt.isLoading || batchReceipt.isLoading,
        data: redeemTx.data || batchReceipt.data,
        error: redeemTx.error || batchReceipt.error,
        submit,
    };
};const getOutcomes = async (conditionEntityIds, client) => {
    const result = await client.query({
        query: ConditionsBatchDocument,
        variables: {
            conditionFilter: {
                id_in: conditionEntityIds,
            },
        },
        fetchPolicy: 'network-only',
    });
    return result?.data?.conditions.reduce((acc, { id: conditionEntityId, outcomes, status }) => {
        outcomes.forEach(({ outcomeId, odds }) => {
            const key = `${conditionEntityId}-${outcomeId}`;
            acc[key] = {
                odds: +odds,
                status,
            };
        });
        return acc;
    }, {});
};
const batchFetchOutcomes = createBatch(getOutcomes);const useSelection = ({ selection, initialOdds, initialStatus }) => {
    const { coreAddress, conditionId, outcomeId } = selection;
    const { appChain, contracts } = useChain();
    const { prematchClient } = useApolloClients();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const config = useConfig();
    const isLive = coreAddress.toLowerCase() === liveHostAddress.toLowerCase();
    const [odds, setOdds] = useState(initialOdds || 0);
    const [isOddsFetching, setOddsFetching] = useState(!initialOdds);
    const [status, setStatus] = useState(initialStatus || ConditionStatus.Created);
    const [isStatusFetching, setStatusFetching] = useState(!initialStatus);
    const isLocked = status !== ConditionStatus.Created;
    useEffect(() => {
        if (!isLive || !isSocketReady) {
            return;
        }
        subscribeToUpdates([conditionId]);
        return () => {
            unsubscribeToUpdates([conditionId]);
        };
    }, [isSocketReady]);
    useEffect(() => {
        const unsubscribe = oddsWatcher.subscribe(`${conditionId}`, `${outcomeId}`, async (oddsData) => {
            let odds = oddsData?.outcomes?.[String(outcomeId)]?.odds;
            if (!odds) {
                const rawOdds = await readContract(config, {
                    address: contracts.prematchCore.address,
                    abi: contracts.prematchCore.abi,
                    functionName: 'calcOdds',
                    chainId: appChain.id,
                    args: [
                        BigInt(conditionId),
                        BigInt(1),
                        BigInt(outcomeId),
                    ],
                });
                odds = formatUnits(rawOdds, ODDS_DECIMALS);
            }
            else {
                setOddsFetching(false);
            }
            setOdds(+odds);
        });
        return () => {
            unsubscribe();
        };
    }, [config]);
    useEffect(() => {
        const unsubscribe = conditionStatusWatcher.subscribe(`${conditionId}`, (newStatus) => {
            setStatusFetching(false);
            setStatus(newStatus);
        });
        return () => {
            unsubscribe();
        };
    }, []);
    useEffect(() => {
        if (isLive || (initialOdds && initialStatus)) {
            return;
        }
        (async () => {
            const conditionEntityId = `${contracts.prematchCore.address.toLowerCase()}_${conditionId}`;
            const key = `${conditionEntityId}-${outcomeId}`;
            const data = await batchFetchOutcomes([conditionEntityId], prematchClient);
            if (!initialOdds) {
                setOdds(data?.[key]?.odds || 0);
                setOddsFetching(false);
            }
            if (!initialStatus) {
                setStatus(data?.[key]?.status || ConditionStatus.Created);
                setStatusFetching(false);
            }
        })();
    }, [prematchClient]);
    return {
        odds,
        isLocked,
        isOddsFetching,
        isStatusFetching,
    };
};const useDeBridgeSupportedChains = ({ enabled } = { enabled: true }) => {
    const queryFn = async () => {
        const response = await fetch(`${deBridgeUrl}/supported-chains-info`);
        const { chains } = await response.json();
        const chainIds = chains.map(({ chainId }) => chainId);
        return {
            chains,
            chainIds,
        };
    };
    const { isFetching, data, refetch } = useQuery$1({
        queryKey: ['/debridge-supported-chains'],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
    });
    return {
        supportedChains: data?.chains,
        supportedChainIds: data?.chainIds,
        refetch,
        loading: isFetching,
    };
};const useDeBridgeSupportedTokens = ({ chainId, enabled = true }) => {
    const queryFn = async () => {
        const response = await fetch(`${deBridgeUrl}/token-list?chainId=${chainId}`);
        const { tokens } = await response.json();
        const supportedTokens = Object.values(tokens);
        return {
            supportedTokens,
            tokenAddresses: supportedTokens.map(({ address }) => address),
        };
    };
    const { isFetching, data, refetch } = useQuery$1({
        queryKey: ['/debridge-supported-tokens', chainId],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
    });
    return {
        supportedTokens: data?.supportedTokens,
        supportedTokenAddresses: data?.tokenAddresses,
        refetch,
        loading: isFetching,
    };
};const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
};var DeBridgeOrderStatus;
(function (DeBridgeOrderStatus) {
    DeBridgeOrderStatus["None"] = "None";
    DeBridgeOrderStatus["Created"] = "Created";
    DeBridgeOrderStatus["Fulfilled"] = "Fulfilled";
    DeBridgeOrderStatus["SentUnlock"] = "SentUnlock";
    DeBridgeOrderStatus["OrderCancelled"] = "OrderCancelled";
    DeBridgeOrderStatus["SentOrderCancel"] = "SentOrderCancel";
    DeBridgeOrderStatus["ClaimedUnlock"] = "ClaimedUnlock";
    DeBridgeOrderStatus["ClaimedOrderCancel"] = "ClaimedOrderCancel";
})(DeBridgeOrderStatus || (DeBridgeOrderStatus = {}));
var DeBridgeExternalCallStatus;
(function (DeBridgeExternalCallStatus) {
    DeBridgeExternalCallStatus["NoExtCall"] = "NoExtCall";
    DeBridgeExternalCallStatus["AwaitingOrderFulfillment"] = "AwaitingOrderFulfillment";
    DeBridgeExternalCallStatus["AwaitingExecution"] = "AwaitingExecution";
    DeBridgeExternalCallStatus["Executing"] = "Executing";
    DeBridgeExternalCallStatus["Completed"] = "Completed";
    DeBridgeExternalCallStatus["Failed"] = "Failed";
    DeBridgeExternalCallStatus["Cancelled"] = "Cancelled";
})(DeBridgeExternalCallStatus || (DeBridgeExternalCallStatus = {}));
const useDeBridgeBet = (props) => {
    const { fromChainId: _fromChainId, fromTokenAddress: _fromTokenAddress, betAmount: _betAmount, slippage, deadline, referralCode, affiliate, selections, odds, totalOdds, onSuccess, onError, } = props;
    const { prematchClient } = useApolloClients();
    const { addBet } = useBetsCache();
    const publicClient = usePublicClient();
    const config = useConfig();
    const account = useAccount();
    const { appChain, betToken, contracts } = useChain();
    const [isBetPending, setBetPending] = useState(false);
    const [isBetProcessing, setBetProcessing] = useState(false);
    const isLiveBet = selections.some(({ coreAddress }) => coreAddress === liveHostAddress);
    const betAmount = useDebounce(_betAmount, 300);
    const fromChainId = useDebounce(_fromChainId, 300);
    const fromTokenAddress = useDebounce(_fromTokenAddress, 300);
    const { supportedChainIds, loading: isDeBridgeSupportedChainsFetching, } = useDeBridgeSupportedChains({
        enabled: !isLiveBet,
    });
    const { supportedTokenAddresses, loading: isDeBridgeSupportedTokensFetching, } = useDeBridgeSupportedTokens({
        chainId: fromChainId,
        enabled: !isLiveBet && !isDeBridgeSupportedChainsFetching && (supportedChainIds || []).includes(fromChainId),
    });
    const queryFn = async () => {
        const fixedAmount = parseFloat(betAmount).toFixed(betToken.decimals);
        const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
        const coreAddress = selections.length > 1 ? contracts.prematchComboCore.address : contracts.prematchCore.address;
        const betData = getPrematchBetDataBytes(selections);
        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
        const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
        const rawDeadline = BigInt(Math.floor(Date.now() / 1000) + (deadline || DEFAULT_DEADLINE));
        const params = new URLSearchParams({
            dstChainId: String(appChain.id),
            srcChainOrderAuthorityAddress: account.address,
            prependOperatingExpenses: 'false',
            srcChainId: String(fromChainId),
            srcChainTokenIn: fromTokenAddress,
            srcChainTokenInAmount: 'auto',
            dstChainTokenOut: betToken.address,
            dstChainTokenOutAmount: String(rawAmount),
            dstChainTokenOutRecipient: account.address,
            dstChainOrderAuthorityAddress: account.address,
            externalCall: JSON.stringify({
                version: 'evm_1',
                fields: {
                    to: contracts.lp.address,
                    data: encodeFunctionData({
                        abi: contracts.lp.abi,
                        functionName: 'betFor',
                        args: [
                            account.address,
                            coreAddress,
                            rawAmount,
                            rawDeadline,
                            {
                                affiliate,
                                minOdds: rawMinOdds,
                                data: betData,
                            },
                        ],
                    }),
                },
            }),
            referralCode: String(referralCode),
        });
        const deBridgeCreateTxResponse = await fetch(`${deBridgeUrl}/dln/order/create-tx?${params}`);
        const data = await deBridgeCreateTxResponse.json();
        return data;
    };
    const selectionsKey = selections.map(({ conditionId }) => conditionId).join('-');
    const { isFetching: isCreateTxFetching, data } = useQuery$1({
        queryKey: ['/debridge-create-tx', fromChainId, fromTokenAddress, account?.address, betAmount, selectionsKey, totalOdds, slippage],
        queryFn,
        enabled: (!isLiveBet
            && !isBetPending
            && !isBetProcessing
            && Boolean(fromChainId)
            && Boolean(fromTokenAddress)
            && Boolean(account)
            && Boolean(+betAmount)
            && Boolean(selections.length)
            && !isDeBridgeSupportedChainsFetching
            && !isDeBridgeSupportedTokensFetching
            && (supportedChainIds || []).includes(appChain.id)
            && (supportedChainIds || []).includes(fromChainId)
            && (supportedTokenAddresses || []).includes(fromTokenAddress)),
        refetchOnWindowFocus: false,
        refetchInterval: 20000,
    });
    const { orderId, estimation, tx: betTxData, fixFee } = data || {};
    const isTxReady = Boolean(betTxData);
    const isNative = estimation?.srcChainTokenIn?.address === zeroAddress;
    const allowanceTx = useReadContract({
        chainId: fromChainId,
        address: estimation?.srcChainTokenIn.address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [
            account.address,
            betTxData?.to,
        ],
        query: {
            enabled: !isNative && Boolean(account.address) && isTxReady,
            refetchOnWindowFocus: false,
        },
    });
    const isApproveRequired = Boolean(allowanceTx.data !== undefined
        && allowanceTx.data < (BigInt(estimation?.srcChainTokenIn?.amount || 0) * 4n / 3n));
    const approveTx = useWriteContract();
    const betTx = useSendTransaction();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
    });
    const approve = async () => {
        try {
            const hash = await approveTx.writeContractAsync({
                address: estimation?.srcChainTokenIn.address,
                abi: erc20Abi,
                chainId: fromChainId,
                functionName: 'approve',
                args: [
                    betTxData?.to,
                    maxUint256,
                ],
            });
            await publicClient.waitForTransactionReceipt({
                hash,
            });
            allowanceTx.refetch();
        }
        catch (err) {
            onError?.(err);
        }
    };
    const placeBet = async () => {
        try {
            setBetPending(true);
            const hash = await betTx.sendTransactionAsync(betTxData);
            setBetPending(false);
            setBetProcessing(true);
            await publicClient.waitForTransactionReceipt({
                hash,
            });
            const txHash = await new Promise((res, rej) => {
                const interval = setInterval(async () => {
                    const orderResponse = await fetch(`${deBridgeUrl}/dln/order/${orderId}`);
                    const order = await orderResponse.json();
                    const { status: orderStatus, externalCallState: betPlacingStatus, } = order;
                    const isBetPlaced = betPlacingStatus === DeBridgeExternalCallStatus.Completed;
                    const isOrderFulfilled = isBetPlaced || orderStatus === DeBridgeOrderStatus.Fulfilled || orderStatus === DeBridgeOrderStatus.ClaimedUnlock;
                    if (isOrderFulfilled) {
                        clearInterval(interval);
                        const orderTxResponse = await fetch(`${deBridgeTxUrl}/orders/${orderId}`);
                        const { fulfilledDstEventMetadata } = await orderTxResponse.json();
                        res(fulfilledDstEventMetadata?.transactionHash?.stringValue);
                    }
                    let error = '';
                    if (betPlacingStatus === DeBridgeExternalCallStatus.Cancelled) {
                        error = DeBridgeExternalCallStatus.Cancelled;
                    }
                    if (betPlacingStatus === DeBridgeExternalCallStatus.Failed) {
                        error = DeBridgeExternalCallStatus.Failed;
                    }
                    if (orderStatus === DeBridgeOrderStatus.SentOrderCancel) {
                        error = DeBridgeOrderStatus.SentOrderCancel;
                    }
                    if (orderStatus === DeBridgeOrderStatus.OrderCancelled) {
                        error = DeBridgeOrderStatus.OrderCancelled;
                    }
                    if (error) {
                        clearInterval(interval);
                        rej(error);
                    }
                }, 5000);
            });
            let receipt;
            if (txHash) {
                receipt = await getTransactionReceipt(config, {
                    hash: txHash,
                    chainId: appChain.id,
                });
                if (receipt) {
                    const fixedAmount = parseFloat(betAmount).toFixed(betToken.decimals);
                    const rawAmount = parseUnits(fixedAmount, betToken.decimals);
                    addBet({
                        receipt,
                        affiliate,
                        odds,
                        bet: {
                            rawAmount,
                            selections,
                        },
                    });
                }
            }
            else {
                prematchClient.refetchQueries({
                    include: ['Bets'],
                });
            }
            setBetProcessing(false);
            onSuccess?.(receipt);
        }
        catch (err) {
            setBetPending(false);
            setBetProcessing(false);
            onError?.(err);
        }
    };
    const submit = () => {
        if (isApproveRequired) {
            return approve();
        }
        return placeBet();
    };
    return {
        orderId,
        submit,
        estimation,
        fixFee,
        supportedChainIds,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        betTx: {
            isPending: isBetPending,
            isProcessing: isBetProcessing,
        },
        isAllowanceLoading: allowanceTx.isLoading,
        isApproveRequired,
        isTxReady,
        loading: isCreateTxFetching || isDeBridgeSupportedChainsFetching,
    };
};const BettorsDocument = gql `
    query Bettors($where: Bettor_filter!) {
  bettors(where: $where, subgraphError: allow) {
    ...Bettor
  }
}
    ${BettorFragmentDoc}`;const useBetsSummary = (props) => {
    const { account, affiliates } = props;
    const { betToken } = useChain();
    const { prematchClient } = useApolloClients();
    const options = useMemo(() => {
        const variables = {
            where: {
                address: account?.toLowerCase(),
            },
        };
        if (affiliates?.length) {
            variables.where.affiliate_in = affiliates.map(affiliate => affiliate.toLowerCase());
        }
        return {
            variables,
            ssr: false,
            client: prematchClient,
            notifyOnNetworkStatusChange: true,
            skip: !account,
        };
    }, [
        account,
        affiliates?.join('-'),
    ]);
    const { data, loading, error } = useQuery(BettorsDocument, options);
    const { bettors } = data || { bettors: [] };
    const formattedData = useMemo(() => {
        if (!bettors.length) {
            return {
                toPayout: '0',
                inBets: '0',
                totalPayout: '0',
                totalProfit: '0',
                betsCount: 0,
                wonBetsCount: 0,
                lostBetsCount: 0,
            };
        }
        const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount, } = bettors.reduce((acc, bettor) => {
            const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount } = bettor;
            acc.rawToPayout += BigInt(rawToPayout);
            acc.rawInBets += BigInt(rawInBets);
            acc.rawTotalPayout += BigInt(rawTotalPayout);
            acc.rawTotalProfit += BigInt(rawTotalProfit);
            acc.betsCount += betsCount;
            acc.wonBetsCount += wonBetsCount;
            acc.lostBetsCount += lostBetsCount;
            return acc;
        }, {
            rawToPayout: 0n,
            rawInBets: 0n,
            rawTotalPayout: 0n,
            rawTotalProfit: 0n,
            betsCount: 0,
            wonBetsCount: 0,
            lostBetsCount: 0,
        });
        return {
            toPayout: formatUnits(rawToPayout, betToken.decimals),
            inBets: formatUnits(rawInBets, betToken.decimals),
            totalPayout: formatUnits(rawTotalPayout, betToken.decimals),
            totalProfit: formatUnits(rawTotalProfit, betToken.decimals),
            betsCount,
            wonBetsCount,
            lostBetsCount,
        };
    }, [data]);
    return {
        ...formattedData,
        loading,
        error,
    };
};export{ApolloProvider,AzuroSDKProvider,BaseBetslipContext,BetStatus,Bet_OrderBy,BetslipDisableReason,BetslipProvider,ChainProvider,ConditionStatus,ConditionsDocument$1 as ConditionsDocument,DetailedBetslipContext,GameDocument,GameStatus,Game_OrderBy,GamesDocument,GameStatus$1 as GraphGameStatus,LiveBetsDocument,LiveContext,LiveProvider,NavigationDocument,OrderDirection,BetsDocument as PrematchBetsDocument,SocketProvider,SportHub,SportsDocument,Watchers,calcLiveOdds,calcMindOdds,calcPrematchOdds,chainsData,cookieKeys,environments,getApolloClients,getBetStatus,getGameStatus,getLiveBetFee,getPrematchBetDataBytes,liveHostAddress,liveSupportedChains,minLiveBetAmount,setGamesCacheTime,useApolloClients,useBaseBetslip,useBetTokenBalance,useBetsSummary,useChain,useConditions,useDeBridgeBet,useDeBridgeSupportedChains,useDeBridgeSupportedTokens,useDetailedBetslip,useGame,useGameMarkets,useGameStatus,useGames,useLive,useLiveBetFee,useLiveBets,useNativeBalance,useOdds,usePrematchBets,usePrepareBet,useRedeemBet,useSelection,useSports,useSportsNavigation,useStatuses,useWatchers};